import React, { useState, useEffect, useRef } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../components/estilos.css';
import {
    listPProduccionUltimoNumeros
} from '../graphql/queries';
import {
    updateRecibaSeriales, createPProduccionUltimoNumero,
    updatePProduccion, updatePProduccionUltimoNumero, createPProduccion, updateAutorizaciones, createAutorizaciones,
    updateRecibaSerialesMP,
    createPProduccionGeneral,
    updatePProduccionGeneral
} from '../graphql/mutations';
import Moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import {
    GetAutorizaciones, GetPlaneacion, GetPProduccion,
    GetProductosID, GetRecibaSeriales, GetRecibaSerialesID, GetUsuarios, GetPProduccionGeneral,
    GetRecibaSerialesMP,
    GetPProduccionGeneralID
} from '../components/queries/Queries';
import { ObtenerSerialesPProduccion, combinarIDS } from '../components/queries/DCUbicaciones';
import { actualizarPPPGeneralM } from '../components/queries/Mutations';
import { onUpdateRecibaSerialesMP } from '../graphql/subscriptions';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Producción' }

export default function usePProduccion() {
    const [reciba, setReciba] = useState([]);
    const [rPANOFIFO, setRPANOFIFO] = useState("");
    const [noFIFOUsuarios, setNOFIFOUsuarios] = useState([]);
    const [noFIFOUsuarios2, setNOFIFOUsuarios2] = useState([]);
    const [usuariosNC, setUsuariosNC] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [recibaFiltrado, setReFiltrado] = useState([]);
    const [planeacionesFiltradas, setPlaneacionesFiltradas] = useState([]);
    const [planeacionSinFiltro, setPlaneacionSinFiltro] = useState([]);
    const [pProduccionSinFiltro, setPProduccionSinFiltro] = useState([]);
    const [planeaciones, setPlaneaciones] = useState([]);
    const [pProduccion, setPProduccion] = useState([]);
    const [pProduccionIncompleta, setPProduccionIncompleta] = useState([]);
    const [editar, setEditar] = useState(false);
    const [numeroP, setNumeroP] = useState(0);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [ultimoNumeroPP, setultimoNumeroPP] = useState(0);
    const [formState, updateFormState] = useState(initialfFormState);
    const [isDisabled, setisDisabled] = useState(false);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [fechaPPBusqueda, setFechaPPBusqueda] = useState("");
    const [numeroPProduccion, setNumeroPProduccion] = useState("");
    const [dhRegresaraAlmacen, setDHRegresaraAlmacen] = useState(true);
    const [regresaraAlmacen, setRegresaraAlmacen] = useState(false);
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pproducciones = window.$Producciones ? window.$Producciones : false;
    const verpproducciones = window.$verPlanProduccion ? window.$verPlanProduccion : false;
    const ppproduccion = window.$Produccion ? window.$Produccion : false;
    const pPlanProduccion = window.$PProduccion ? window.$PProduccion : false;
    const pproduccionCalidad = window.$ProduccionCalidad ? window.$ProduccionCalidad : false;
    const pproduccionInspeccion = window.$ProduccionInspeccion ? window.$ProduccionInspeccion : false;
    const pproduccionRecuperacion = window.$ProduccionRecuperacion ? window.$ProduccionRecuperacion : false;
    const verpplaneacion = window.$verPlaneacion ? window.$verPlaneacion : false;
    const [cargando, setCargando] = useState(false);
    const [cargando1, setCargando1] = useState(false);
    const [pcargando, setPCargando] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [vistaUltimoAP, setVistaUltimoAP] = useState(false);
    const [fechaPlaneacion, setFechaPlaneacion] = useState("");
    const [fechaPlaneacionM, setFechaPlaneacionM] = useState("");
    const [fechaPlaneacionS, setFechaPlaneacionS] = useState("");
    const [fechaPlaneacionP, setFechaPlaneacionP] = useState("");
    const [sumProduccion, setSumProduccion] = useState("");
    const [sumProduccionp, setSumProduccionp] = useState("");
    const [sumCiclos, setSumCiclos] = useState("");
    const [sumICiclos, setSumICiclos] = useState("");
    const [sumPiezasPP, setSumPiezasPP] = useState("");
    //const [dia, setDia] = useState("");
    const [fPDisabled, setFPDisabled] = useState(true);
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [paginas, setPaginas] = useState([]);
    const [paginasP, setPaginasP] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [aceptarFinalizar, setAceptarFinalizar] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [comentariosNoFIFO, setComentariosNoFIFO] = useState("");
    const [usuarioAutNoFIFO, setUsuarioAutNoFIFO] = useState("");
    const [usuarioAutNoFIFO2, setUsuarioAutNoFIFO2] = useState("");
    const [modificados, setModificados] = useState([]);
    const [espaciosVacios, setEspaciosVacios] = useState(0);
    const [textPQR, setPQR] = useState("Con código QR");
    const [bloquearAgregado, setBloquearAgregado] = useState(false);
    const [vistaNumeroParte, setVistaNumeroParte] = useState(false);
    const [dataChart, SetDataChart] = useState({});
    const colores = ["#800000", "#8B0000", "#A52A2A", "#B22222", "#DC143C", "#FF0000", "#FF6347",
        "#FF7F50", "#CD5C5C", "#F08080", "#E9967A", "#FA8072", "#FFA07A", "#FF4500", "#FF8C00",
        "#FFA500", "#FFD700", "#B8860B", "#DAA520", "#EEE8AA", "#BDB76B", "#F0E68C", "#808000",
        "#FFFF00", "#9ACD32", "#556B2F", "#6B8E23", "#7CFC00", "#7FFF00", "#ADFF2F", "#006400",
        "#008000", "#228B22", "#00FF00", "#32CD32", "#90EE90", "#98FB98", "#8FBC8F", "#00FA9A",
        "#00FF7F", "#2E8B57", "#66CDAA", "#3CB371", "#20B2AA", "#2F4F4F", "#008080", "#008B8B",
        "#00FFFF", "#00FFFF", "#E0FFFF", "#00CED1", "#40E0D0", "#48D1CC", "#AFEEEE", "#7FFFD4",
        "#B0E0E6", "#5F9EA0", "#4682B4", "#6495ED", "#00BFFF", "#1E90FF", "#ADD8E6", "#87CEEB",
        "#87CEFA", "#191970", "#000080", "#00008B", "#0000CD", "#0000FF", "#4169E1", "#8A2BE2",
        "#4B0082", "#483D8B", "#6A5ACD", "#7B68EE", "#9370DB", "#8B008B", "#9400D3", "#9932CC",
        "#BA55D3", "#800080", "#D8BFD8", "#DDA0DD", "#EE82EE", "#FF00FF", "#DA70D6", "#C71585",
        "#DB7093", "#FF1493", "#FF69B4", "#FFB6C1", "#FFC0CB", "#FAEBD7", "#F5F5DC", "#FFE4C4",
        "#FFEBCD", "#F5DEB3", "#FFF8DC", "#FFFACD", "#FAFAD2", "#FFFFE0", "#8B4513", "#A0522D",
        "#D2691E", "#CD853F", "#F4A460", "#DEB887", "#D2B48C", "#BC8F8F", "#FFE4B5", "#FFDEAD",
        "#FFDAB9", "#FFE4E1", "#FFF0F5", "#FAF0E6", "#FDF5E6", "#FFEFD5", "#FFF5EE", "#F5FFFA",
        "#708090", "#778899", "#B0C4DE", "#E6E6FA", "#FFFAF0", "#F0F8FF", "#F8F8FF", "#F0FFF0",
        "#FFFFF0", "#F0FFFF", "#FFFAFA", "#000000", "#696969", "#808080", "#A9A9A9", "#C0C0C0",
        "#D3D3D3", "#DCDCDC", "#F5F5F5", "#FFFFFF"
    ]
    //const [datoID, setDatoID] = useState();
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    now2.setDate(now2.getDate() - 5);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

    var pnow = new Date();
    var pnow2 = new Date();
    pnow2.setDate(pnow2.getDate() - 5);
    pnow.setDate(pnow.getDate() + 5);
    const [rpfechaini, setRPfechaini] = useState(Moment(pnow2).format("YYYY-MM-DD"));
    const [rpfechafin, setRPfechafin] = useState(Moment(pnow).format("YYYY-MM-DD"));

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    };

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);
    const toggle3 = () => setModal3(!modal3);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePlaneacion, setCurrentPagePlaneacion] = useState(1);
    const [currentPagePProduccion, setCurrentPagePProduccion] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;

    function handleError(err) {
        console.error(err)
    };

    function handleScan(data) {
        if (data) {
            const datosPlaneacion = recibaSinFiltro.filter(Ralmacen => Ralmacen.id === data.replaceAll('\'', '-'))
            if (datosPlaneacion.length && datosPlaneacion[0].piezasenAlmacen > 0) {
                if (datosPlaneacion[0].cantidadPlaneada >= datosPlaneacion[0].piezasenAlmacen) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: Material ya planificado.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                } else {
                    setPQR("Con código QR");
                    clicAdddeAlmacen(datosPlaneacion[0]);
                }
            } else {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: el código QR no coincide con ningún número de serie disponible para su planeación, favor de buscar el material que corresponda y volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);

            }
        }
        return <p>{data}</p>
    };
    function clicConQR() {
        //setRegistroIndividual(false);
        if (textPQR === "Con código QR") {
            setPQR("Finalizar agregado");
            //setCargaCompleta(false);
            // moveralSiguiente();
        } else {
            setPQR("Con código QR");
            //fetchPlanProduccionPEyP();
        }

    };

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber, vistaUltimoAP);
    }

    // handle change event
    function handlePageChangePlaneacion(pageNumber) {
        setAVisible(false);
        setCurrentPagePlaneacion(pageNumber);
        busquedaPlaneacion(planeacionesFiltradas, pageNumber, fechaPBusqueda);
    }

    // handle change event
    function handlePageChangePProduccion(pageNumber) {
        window.scrollTo(0, 0);
        setAVisible(false);
        setCargando(true);
        setCurrentPagePProduccion(pageNumber);
        busquedaPProduccion(pProduccionSinFiltro, pageNumber, fechaPPBusqueda, vistaNumeroParte);
    }

    async function busquedaPlaneacion(planeacionsf, currentPage, fechaBusqueda) {
        var i = 1;
        var paginasp = [];
        var p = 0;
        var pi = 1;
        var racks = 0;
        var ciclos = 0;

        planeacionsf = planeacionsf.filter(planeacion => fechaBusqueda ? planeacion.fechaDePlaneacion === fechaBusqueda :
            planeacion.fechaDePlaneacion === planeacion.fechaDePlaneacion).filter(planeacion =>
                parseInt(planeacion.cantidadPlanProduccion) < parseInt(planeacion.cantidadPiezas) || !planeacion.cantidadPlanProduccion)
        await Promise.all(planeacionsf.map(async planeacion => {
            if (planeacion.numero !== p) {
                paginasp.push({ pagina: pi, paginareal: planeacion.numero });
                p = planeacion.numero;
                pi++;
            }
            planeacion.paginacion = pi - 1;
            return planeacion;
        }));
        if (currentPage < 1) {
            currentPage = 1;
            setCurrentPagePlaneacion(1);
        }

        if (currentPage > pi - 1) {
            currentPage = currentPage - 1;
            setCurrentPagePlaneacion(currentPage);
        }
        setultimoNumeroP(pi - 1);
        const planeacioncp = planeacionsf.filter(planeacion => planeacion.paginacion === currentPage).sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        if (planeacioncp.length)
            setFechaPlaneacionP(planeacioncp[0].fechaDePlaneacion);

        await Promise.all(planeacioncp.map(async planeacion => {
            planeacion.color = "";
            if (i === 2) {
                planeacion.color = "table-active";
                i = 0;
            }
            i++;
            racks += parseFloat(planeacion.racks);
            ciclos += parseFloat(planeacion.ciclos);
            return planeacion;
        }));
        if (racks > 0)
            setSumProduccion(racks.toFixed(2) + " RACKS " + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN")
        else
            setSumProduccion("");

        if (ciclos > 0)
            setSumCiclos(ciclos + " CICLOS")
        else
            setSumCiclos("");


        setPlaneaciones(planeacioncp);
        if (planeacionsf.length) {
            setPaginas(paginasp);
        } else {
            setPaginas([]);
        }
    }
    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage, vistaUAP) {
        var pag = 1;
        var bandera = 1;
        var num = 0;
        //Se revisa el tipo de vista que se requiere de los datos        
        var recibaFromAPI = vistaUAP === true ? recibasinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0) :
            recibasinf.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
        //Se agrega el número de registro y se ponen los datos en reciba sin filtro
        await Promise.all(recibaFromAPI.map(async reciba => {
            reciba.registro = num;
            num++;
            reciba.updatedAt = reciba.rsUpdatedAt;
            return reciba;
        }));
        // se asigna a setRecibaSinFiltro los datos sin filtrado por piezasenAlmacen
        setRecibaSinFiltro(recibaFromAPI);
        // se asigna a setReFiltrado los datos filtrados por piezasenAlmacen: {gt: 0}
        recibaFromAPI = recibaFromAPI.filter(reciba => reciba.piezasenAlmacen > 0);
        setReFiltrado(recibaFromAPI);

        //Filtrado de datos por la búsqueda y el estado de reciba
        recibaFromAPI = recibaFromAPI.filter(reciba => (parseInt(reciba.cantidadRecibida) -
            parseInt(reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0)) > 0).filter(reciba =>
                estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                    searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                    searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                        search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                        searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                            searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                                reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));


        await Promise.all(recibaFromAPI.map(async reciba => {
            const restFechas = (new Date()).getTime() - (new Date(reciba.fechaDeReciba)).getTime();
            reciba.FEPlanta = Math.round(restFechas / (1000 * 60 * 60 * 24));
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))


        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.filter(reciba => reciba.indexpag === paginas);
                setReciba(recibaFromAPIp);
            }
        }
        setCargando1(false);
    }
    async function busquedaPProduccion(pproducciong, currentPage, fechaBusqueda, vistaNP) {
        var paginasp = [];
        var p = 0;
        var pi = 1;
        var racks = 0;
        var racksPintados = 0;
        var ciclos = 0;
        var cargadas = 0;
        var pintadas = 0;
        var cargadasPC = 0;
        var pintadasPC = 0;
        var inspeccionadas = 0;
        var arecuperacion = 0;
        var aembarcar = 0;

        var completo = true;

        /* pproducciong = pproducciong.filter(pproduccion => fechaBusqueda ? pproduccion.fechaDePlaneacion === fechaBusqueda :
             pproduccion.fechaDePlaneacion === pproduccion.fechaDePlaneacion)*/
        //Si existen planeaciones a mostrar          
        if (pproducciong.length > 0) {
            await Promise.all(pproducciong.map(async pproduccion => {
                if (pproduccion.numero !== p) {
                    paginasp.push({ pagina: pi, paginareal: pproduccion.numero });
                    p = pproduccion.numero;
                    pi++;
                }
                pproduccion.paginacion = pi - 1;
                return pproduccion;
            }));
            //setPProduccionSinFiltro(pproducciong);
            //Se filtran los datos por la página solicitada
            pproducciong = pproducciong.filter(pproduccion => pproducciong.length === 1 ? pproduccion.paginacion === pproduccion.paginacion :
                pproduccion.paginacion === currentPage);

            const ppF = pproducciong.length > 0 ? await ObtenerSerialesPProduccion(pproducciong[0]) : [];
            var pproduccionsf = ppF.pproduccion;
            //setPProduccionSinFiltro(pproduccionsf);
            if (currentPage < 1) {
                currentPage = 1;
                setCurrentPagePProduccion(1);
            }

            if (currentPage > pi - 1) {
                currentPage = currentPage - 1;
                setCurrentPagePProduccion(currentPage);
            }
            var sumEmpaques = 0;
            var sumRacks = 0;
            var sumCantidad = 0;
            var sumCiclos = 0;
            var sumPCargadas = 0;
            var sumPPintadas = 0;
            var sumpRecuperadas = 0;
            var sumPInspeccionadas = 0;
            var sumPIRecuperacion = 0;
            var sumPEmbarcadas = 0;
            var sumPRecuperadas = 0;
            var sumPNRecuperadas = 0;
            var sumPNoAceptadas = 0;
            var sumPCalidad = 0;
            if (vistaNP === true) {
                var pproduccionANP = [];
                var pproduccionCOM = [];
                var pproduccionSOANP = await pproduccionsf.sort((a, b) =>
                    a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);
                var piezasPMCP = (parseInt(pproduccionSOANP[0].piezasenPintadoAnterior ? pproduccionSOANP[0].piezasenPintadoAnterior : -1) <
                    parseInt(pproduccionSOANP[0].cantidadPiezas ? pproduccionSOANP[0].cantidadPiezas : 0)) ? true : false;

                sumEmpaques = piezasPMCP === true ? parseFloat(pproduccionSOANP[0].materialEnCantidad) : 0;
                sumRacks = piezasPMCP === true ? parseFloat(pproduccionSOANP[0].racks) : 0;
                sumCantidad = parseInt(pproduccionSOANP[0].cantidadPiezas);
                sumCiclos = piezasPMCP === true ? parseFloat(pproduccionSOANP[0].ciclos) : 0;
                sumPCargadas = parseInt(pproduccionSOANP[0].piezasenCarga ? pproduccionSOANP[0].piezasenCarga : 0);
                sumPPintadas = parseInt(pproduccionSOANP[0].piezasenPintado ? pproduccionSOANP[0].piezasenPintado : 0);
                sumpRecuperadas = parseInt(pproduccionSOANP[0].piezasTRecuperacion ? pproduccionSOANP[0].piezasTRecuperacion : 0);
                sumPCalidad = parseInt(pproduccionSOANP[0].piezasCalidad ? pproduccionSOANP[0].piezasCalidad : 0);
                sumPIRecuperacion = parseInt(pproduccionSOANP[0].piezasIRecuperacion ? pproduccionSOANP[0].piezasIRecuperacion : 0);
                sumPInspeccionadas = parseInt(pproduccionSOANP[0].piezasInspeccion ? pproduccionSOANP[0].piezasInspeccion : 0);
                sumPRecuperadas = parseInt(pproduccionSOANP[0].piezasRecuperadas ? pproduccionSOANP[0].piezasRecuperadas : 0);
                sumPNRecuperadas = parseInt(pproduccionSOANP[0].piezasNRecuperadas ? pproduccionSOANP[0].piezasNRecuperadas : 0);
                sumPNoAceptadas = parseInt(pproduccionSOANP[0].piezasNoAceptadas ? pproduccionSOANP[0].piezasNoAceptadas : 0);
                sumPEmbarcadas = parseInt(pproduccionSOANP[0].piezasPintadas ? pproduccionSOANP[0].piezasPintadas : 0);
                //var uplaneacion={};

                await Promise.all(pproduccionSOANP.map(async (pproduccion, j) => {
                    pproduccionCOM.push({ ...pproduccion })
                    if (pproduccionSOANP.length > j + 1) {
                        piezasPMCP = (parseInt(pproduccionSOANP[j + 1].piezasenPintadoAnterior ? pproduccionSOANP[j + 1].piezasenPintadoAnterior : -1) <
                            parseInt(pproduccionSOANP[j + 1].cantidadPiezas ? pproduccionSOANP[j + 1].cantidadPiezas : 0)) ? true : false;
                        if (pproduccion.numerodeParte === pproduccionSOANP[j + 1].numerodeParte && pproduccion.cliente === pproduccionSOANP[j + 1].cliente &&
                            pproduccion.descripcion === pproduccionSOANP[j + 1].descripcion) {
                            sumRacks = sumRacks + (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].racks) : 0);
                            sumCantidad = sumCantidad + (parseInt(pproduccionSOANP[j + 1].cantidadPiezas));
                            sumCiclos = sumCiclos + (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].ciclos) : 0);
                            sumEmpaques = sumEmpaques + (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].materialEnCantidad) : 0);
                            sumPCargadas = sumPCargadas + (parseInt(pproduccionSOANP[j + 1].piezasenCarga ? pproduccionSOANP[j + 1].piezasenCarga : 0));
                            sumPPintadas = sumPPintadas + (parseInt(pproduccionSOANP[j + 1].piezasenPintado ? pproduccionSOANP[j + 1].piezasenPintado : 0));
                            sumpRecuperadas = sumpRecuperadas + (parseInt(pproduccionSOANP[j + 1].piezasTRecuperacion ? pproduccionSOANP[j + 1].piezasTRecuperacion : 0));
                            sumPCalidad = sumPCalidad + (parseInt(pproduccionSOANP[j + 1].piezasCalidad ? pproduccionSOANP[j + 1].piezasCalidad : 0));
                            sumPIRecuperacion = sumPIRecuperacion + (parseInt(pproduccionSOANP[j + 1].piezasIRecuperacion ? pproduccionSOANP[j + 1].piezasIRecuperacion : 0));
                            sumPInspeccionadas = sumPInspeccionadas + parseInt(pproduccionSOANP[j + 1].piezasInspeccion ? pproduccionSOANP[j + 1].piezasInspeccion : 0);
                            sumPRecuperadas = sumPRecuperadas + parseInt(pproduccionSOANP[j + 1].piezasRecuperadas ? pproduccionSOANP[j + 1].piezasRecuperadas : 0);
                            sumPNRecuperadas = sumPNRecuperadas + parseInt(pproduccionSOANP[j + 1].piezasNRecuperadas ? pproduccionSOANP[j + 1].piezasNRecuperadas : 0);
                            sumPNoAceptadas = sumPNoAceptadas + parseInt(pproduccionSOANP[j + 1].piezasNoAceptadas ? pproduccionSOANP[j + 1].piezasNoAceptadas : 0);
                            sumPEmbarcadas = sumPEmbarcadas + parseInt(pproduccionSOANP[j + 1].piezasPintadas ? pproduccionSOANP[j + 1].piezasPintadas : 0);

                        } else {
                            const scUnaInspeccion = pproduccionSOANP.filter(pproduccionNP => (pproduccionNP.numerodeParte === pproduccion.numerodeParte
                                && pproduccionNP.cUnaInspeccion ? pproduccionNP.cUnaInspeccion : false) === true);
                            pproduccionANP.push({
                                ...pproduccion, materialEnCantidad: sumEmpaques,
                                racks: sumRacks.toFixed(2), cantidadPiezas: sumCantidad, ciclos: sumCiclos,
                                piezasenCarga: sumPCargadas, piezasenPintado: sumPPintadas, piezasInspeccion: sumPInspeccionadas,
                                piezasCalidad: sumPCalidad, piezasTRecuperacion: sumpRecuperadas, piezasPintadas: sumPEmbarcadas,
                                piezasIRecuperacion: sumPIRecuperacion, piezasRecuperadas: sumPRecuperadas, piezasNRecuperadas: sumPNRecuperadas,
                                piezasNoAceptadas: sumPNoAceptadas, cUnaInspeccion: scUnaInspeccion.length > 0 ? true : false
                            });


                            sumRacks = (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].racks) : 0);
                            sumCantidad = (parseInt(pproduccionSOANP[j + 1].cantidadPiezas));
                            sumCiclos = (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].ciclos) : 0);
                            sumEmpaques = (piezasPMCP === true ? parseFloat(pproduccionSOANP[j + 1].materialEnCantidad) : 0);
                            sumPCargadas = (parseInt(pproduccionSOANP[j + 1].piezasenCarga ? pproduccionSOANP[j + 1].piezasenCarga : 0));
                            sumPPintadas = (parseInt(pproduccionSOANP[j + 1].piezasenPintado ? pproduccionSOANP[j + 1].piezasenPintado : 0));
                            sumpRecuperadas = (parseInt(pproduccionSOANP[j + 1].piezasTRecuperacion ? pproduccionSOANP[j + 1].piezasTRecuperacion : 0));
                            sumPCalidad = (parseInt(pproduccionSOANP[j + 1].piezasCalidad ? pproduccionSOANP[j + 1].piezasCalidad : 0));
                            sumPIRecuperacion = (parseInt(pproduccionSOANP[j + 1].piezasIRecuperacion ? pproduccionSOANP[j + 1].piezasIRecuperacion : 0));
                            sumPInspeccionadas = parseInt(pproduccionSOANP[j + 1].piezasInspeccion ? pproduccionSOANP[j + 1].piezasInspeccion : 0);
                            sumPRecuperadas = parseInt(pproduccionSOANP[j + 1].piezasRecuperadas ? pproduccionSOANP[j + 1].piezasRecuperadas : 0);
                            sumPNRecuperadas = parseInt(pproduccionSOANP[j + 1].piezasNRecuperadas ? pproduccionSOANP[j + 1].piezasNRecuperadas : 0);
                            sumPNoAceptadas = parseInt(pproduccionSOANP[j + 1].piezasNoAceptadas ? pproduccionSOANP[j + 1].piezasNoAceptadas : 0);
                            sumPEmbarcadas = parseInt(pproduccionSOANP[j + 1].piezasPintadas ? pproduccionSOANP[j + 1].piezasPintadas : 0);
                        }
                    } else {
                        const scUnaInspeccion = pproduccionSOANP.filter(pproduccionNP => (pproduccionNP.numerodeParte === pproduccion.numerodeParte
                            && pproduccionNP.cUnaInspeccion ? pproduccionNP.cUnaInspeccion : false) === true);
                        pproduccionANP.push({
                            ...pproduccion, materialEnCantidad: sumEmpaques,
                            racks: sumRacks.toFixed(2), cantidadPiezas: sumCantidad, ciclos: sumCiclos,
                            piezasenCarga: sumPCargadas, piezasenPintado: sumPPintadas, piezasInspeccion: sumPInspeccionadas,
                            piezasCalidad: sumPCalidad, piezasTRecuperacion: sumpRecuperadas, piezasPintadas: sumPEmbarcadas,
                            piezasIRecuperacion: sumPIRecuperacion, piezasRecuperadas: sumPRecuperadas, piezasNRecuperadas: sumPNRecuperadas,
                            piezasNoAceptadas: sumPNoAceptadas, cUnaInspeccion: scUnaInspeccion.length > 0 ? true : false
                        });
                    }

                    return pproduccion;
                }));

                pproduccionsf = pproduccionANP;
            }
            setultimoNumeroPP(pi - 1);
            const pproduccioncp = pproduccionsf.sort((a, b) =>
                a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
            if (pproducciong.length > 0) {
                const produccionGeneral = pproducciong[0];
                const fechaPProduccion = produccionGeneral.fechaDePlaneacion;
                const hoy = new Date();
                //hoy.setDate(hoy.getDate() -6);
                //Se obtiene el número de espacios vacíos
                if (produccionGeneral.id) {
                    setEspaciosVacios(produccionGeneral.espacioVacio);
                } else {
                    setEspaciosVacios(0);
                }
                setFechaPlaneacionM(fechaPProduccion);
                setNumeroPProduccion(produccionGeneral.numero);
                const dia = hoy.getDay();
                //setDia(dia);
                if (Moment(fechaPProduccion).format("YYYY-MM-DD") === Moment(hoy).format("YYYY-MM-DD")) {
                    if (dia === 5) {
                        //now.setDate(now.getDate() + 5);
                        hoy.setDate(hoy.getDate() + 3);
                    } else if (dia === 6) {
                        hoy.setDate(hoy.getDate() + 2);

                    } else {
                        hoy.setDate(hoy.getDate() + 1);
                    }
                }
                setFechaPlaneacionS(Moment(hoy).format("YYYY-MM-DD"));
            } else {
                setNumeroPProduccion(0);
            }
            var pproduccioncomentes = [];
            var numParte = [];
            var parteCantidad = [];
            var parteColor = [];
            if (vistaNP === true) {
                pproduccioncomentes = pproduccionCOM.sort((a, b) =>
                    (a.cliente + a.numerodeParte + a.serial) > (b.cliente + b.numerodeParte + b.serial) ? 1 :
                        (a.cliente + a.numerodeParte + a.serial) < (b.cliente + b.numerodeParte + b.serial) ? -1 : 0);
            } else {
                pproduccioncomentes = pproduccionsf.sort((a, b) =>
                    (a.cliente + a.numerodeParte + a.serial) > (b.cliente + b.numerodeParte + b.serial) ? 1 :
                        (a.cliente + a.numerodeParte + a.serial) < (b.cliente + b.numerodeParte + b.serial) ? -1 : 0);
            }
            await Promise.all(pproduccioncomentes.map(async (pproduccion, i) => {
                if ((parseInt(pproduccion.piezasPintadas ? pproduccion.piezasPintadas : 0) +
                    parseInt(pproduccion.piezasTRecuperacion ? pproduccion.piezasTRecuperacion : 0) +
                    parseInt(pproduccion.piezasNoAceptadas ? pproduccion.piezasNoAceptadas : 0) +
                    parseInt(pproduccion.piezasTransferidas ? pproduccion.piezasTransferidas : 0)) <
                    (parseInt(pproduccion.cantidadPiezas ? pproduccion.cantidadPiezas : 0))) {
                    //completo = false;
                    pproduccion.completo = false;
                    pproduccion.piezasATransferir = (parseInt(pproduccion.cantidadPiezas ? pproduccion.cantidadPiezas : 0)) -
                        ((parseInt(pproduccion.piezasPintadas ? pproduccion.piezasPintadas : 0) +
                            //parseInt(pproduccion.piezasTRecuperacion ? pproduccion.piezasTRecuperacion : 0) +
                            parseInt(pproduccion.piezasTransferidas ? pproduccion.piezasTransferidas : 0) +
                            parseInt(pproduccion.piezasNoAceptadas ? pproduccion.piezasNoAceptadas : 0))/* - *2
                            (//parseInt(pproduccion.piezasRecuperadas ? pproduccion.piezasRecuperadas : 0) +
                                parseInt(pproduccion.piezasNRecuperadas ? pproduccion.piezasNRecuperadas : 0))*/);
                    //Si las piezasATransferir son mayor que cantidadPiezas del plan de producción, se pone cantidadPiezas como piezas a transferir
                    if (pproduccion.piezasATransferir > pproduccion.cantidadPiezas) {
                        pproduccion.piezasATransferir = pproduccion.cantidadPiezas;
                    }
                    pproduccion.piezasCompletas = ((parseInt(pproduccion.piezasPintadas ? pproduccion.piezasPintadas : 0) +
                        //parseInt(pproduccion.piezasTRecuperacion ? pproduccion.piezasTRecuperacion : 0) +
                        parseInt(pproduccion.piezasTransferidas ? pproduccion.piezasTransferidas : 0))) +
                        (parseInt(pproduccion.piezasNoAceptadas ? pproduccion.piezasNoAceptadas : 0));/* -
                        (parseInt(pproduccion.piezasRecuperadas ? pproduccion.piezasRecuperadas : 0) +
                            parseInt(pproduccion.piezasNRecuperadas ? pproduccion.piezasNRecuperadas : 0)));*/

                } else {
                    pproduccion.completo = true;
                }
                if ((pproduccion.piezasenPintadoAnterior ? pproduccion.piezasenPintadoAnterior : -1) <
                    (pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0)) {
                    racks += parseFloat(pproduccion.racks);
                    ciclos += parseFloat(pproduccion.ciclos); //pproducciong[0]
                    if (pproduccion.cargaFechaHora) {
                        cargadas += (pproduccion.cargaFechaHora.includes(pproducciong[0].fechaDePlaneacion) ?
                            parseFloat(pproduccion.piezasCargaPG ? pproduccion.piezasCargaPG : 0) : 0);
                    }
                    if (pproduccion.pintadoFechaHora) {
                        pintadas += (pproduccion.pintadoFechaHora.includes(pproducciong[0].fechaDePlaneacion) ?
                            parseFloat(pproduccion.piezasPintadoPG ? pproduccion.piezasPintadoPG : 0) : 0);
                        ;
                    }
                    if (pproduccion.cargaFechaHoraPC) {
                        cargadasPC += (pproduccion.cargaFechaHoraPC.includes(pproducciong[0].fechaDePlaneacion) ?
                            parseFloat(pproduccion.piezasCargaPGPC ? pproduccion.piezasCargaPGPC : 0) : 0);
                    }
                    if (pproduccion.pintadoFechaHoraPC) {
                        pintadasPC += (pproduccion.pintadoFechaHoraPC.includes(pproducciong[0].fechaDePlaneacion) ?
                            parseFloat(pproduccion.piezasPintadoPGPC ? pproduccion.piezasPintadoPGPC : 0) : 0);
                        ;
                    }
                    arecuperacion += parseFloat(pproduccion.piezasTRecuperacion ? pproduccion.piezasTRecuperacion : 0);
                    if (pproduccion.piezasenPintado === pproduccion.cantidadPiezas) {
                        racksPintados += parseFloat(pproduccion.racks ? pproduccion.racks : 0);
                    } else {
                        if (parseInt(pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0) > 0) {
                            const racksxpiezas = parseFloat(pproduccion.racks) / parseFloat(pproduccion.cantidadPiezas);
                            racksPintados += parseFloat(racksxpiezas * pproduccion.piezasenPintado) > 0 ?
                                parseFloat(racksxpiezas * pproduccion.piezasenPintado) : 0;
                        }
                    }
                }
                inspeccionadas += parseFloat(pproduccion.piezasInspeccion ? pproduccion.piezasInspeccion : 0) -
                    (parseInt(pproduccion.piezasInspeccionAnterior ? pproduccion.piezasInspeccionAnterior : -1) >
                        parseInt(pproduccion.piezasInspeccion ? pproduccion.piezasInspeccion : 0) ?
                        parseInt(pproduccion.piezasInspeccion ? pproduccion.piezasInspeccion : 0) :
                        parseInt(pproduccion.piezasInspeccionAnterior ? pproduccion.piezasInspeccionAnterior : 0));

                aembarcar += (!pproduccion.Pcoat ? parseFloat(pproduccion.piezasAceptadasPG ? pproduccion.piezasAceptadasPG : 0) : 0) +
                    parseFloat(pproduccion.piezasNoAceptadasPG ? pproduccion.piezasNoAceptadasPG : 0) +
                    parseFloat(pproduccion.piezasAceptadasPGPC ? pproduccion.piezasAceptadasPGPC : 0) +
                    parseFloat(pproduccion.piezasNoAceptadasPGPC ? pproduccion.piezasNoAceptadasPGPC : 0);

                numParte.push(pproduccion.numerodeParte);
                parteCantidad.push(pproduccion.cantidadPiezas);
                const numi = Math.floor(Math.random() * 131);
                parteColor.push(colores[numi]);

                //Si el material está completo=false, se revisa si todavía se encuentra en planta, si ya no está en planta se pone completo=true.
                if (pproduccion.completo === false) {
                    const rSerial = await GetRecibaSerialesID(pproduccion.recibaSerialID);
                    if (!rSerial.id || rSerial.piezasEnPlanta === false) {
                        pproduccion.completo = true;
                        // completo = true;
                    }
                }
                return pproduccion;
            }));
            completo = pproduccioncomentes.filter(pp => pp.completo === false);
            setFPDisabled(completo.length > 0 ? false : true);
            if (racks > 0)
                setSumProduccionp(racksPintados.toFixed(2) + "/" + racks.toFixed(2) + " RACKS " + (racksPintados / 19).toFixed(2) + "/" + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN")
            else
                setSumProduccionp("");

            if (ciclos > 0)
                setSumICiclos(ciclos + " CICLOS");
            else
                setSumICiclos("");

            setSumPiezasPP((cargadas > 0 ? ("PIEZAS CARGADAS ECOAT " + cargadas) : "") + (pintadas > 0 ? (", PIEZAS PINTADAS ECOAT " + pintadas) : "") + ", " +
                (cargadas > 0 ? ("PIEZAS CARGADAS PCOAT " + cargadasPC) : "") + (pintadas > 0 ? (", PIEZAS PINTADAS PCOAT " + pintadasPC) : "") +
                (inspeccionadas > 0 ? (", PIEZAS INSPECCIONADAS " + inspeccionadas) : "") + (arecuperacion > 0 ? (", EN RECUPERACION " + arecuperacion) : "") +
                (aembarcar > 0 ? (", A EMBARCAR " + aembarcar) : ""));

            SetDataChart({
                labels: numParte,
                datasets: [{
                    label: "Cantidad",
                    data: parteCantidad,
                    backgroundColor: parteColor,
                }]
            })
            setPProduccion(pproduccioncp);
            const PProduccionIncompleta = pproduccioncp.filter(pproduccionsf => pproduccionsf.completo === false)
            setPProduccionIncompleta(PProduccionIncompleta);
            if (pproduccionsf.length) {
                setPaginasP(paginasp);
            } else {
                setPaginasP([]);
            }
        } else {
            setSumICiclos("");
            setSumProduccionp("");
            setSumPiezasPP("");
            setPProduccion([]);
            setPaginasP([]);
        }
        setCargando(false);
    }
    //Vista por número de parte
    function onChangescheckVNP(e) {
        setVistaNumeroParte(e.target.checked);
        busquedaPProduccion(pProduccionSinFiltro, currentPagePProduccion, fechaPPBusqueda, e.target.checked);
    }
    //Método useEffect
    useEffect(() => {
        fetchPlanProduccion(rfechaini, rfechafin);
        fetchReciba();
        //fetchPlaneaciones(rpfechaini, rpfechafin);
        fetchUsuario();
        subscriptions();
    }, []);

    //Función que crea las subscripciones
    function subscriptions() {
        //se suscriben para los cambios en planeación base
        const variables = {
            filter: {
                // filtro en base a la fecha de pintado.
                or: [{
                    pintadoFechaHora: {
                        contains: Moment(new Date()).format("YYYY-MM-DD"),
                    }
                },
                {
                    cargaFechaHora: {
                        contains: Moment(new Date()).format("YYYY-MM-DD"),
                    },
                },
                {
                    calidadFechaHora: {
                        contains: Moment(new Date()).format("YYYY-MM-DD"),
                    },
                }
                ]
            }
        };

        //Subscripciones de la planeación base
        API.graphql({ query: onUpdateRecibaSerialesMP, variables }).subscribe({
            next: ({ provider, value }) => datosPlanProduccion(rfechaini, rfechafin), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

    }

    //Obtiene los usuarios activos con permisos para autorizar no usar FIFO en planeación.
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            activo: {
                eq: true
            }

        }
        //Se obtienen los datos de los usuarios.
        const apiData = await GetUsuarios(filter);
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        const usuarioLG = dataFromAPI.filter(usuarios => usuarios.usuario === userName);
        setUsuariosNC(usuarioLG[0] ? usuarioLG[0].nombreCompleto : "");
        setNOFIFOUsuarios(dataFromAPI.filter(usuarios => usuarios.PProduccionAutNoFIFO1 === true));
        setNOFIFOUsuarios2(dataFromAPI.filter(usuarios => usuarios.PProduccionAutNoFIFO2 === true));
    }
    //Obtiene los datos guardados de las planeaciones
    async function fetchPlaneaciones(fechainicial, fechafinal) {
        //Filtro por planeación activa
        setPCargando(true);
        let filter = {
            activo: {
                eq: true
            }
        }
        //Se obtienen los datos de las planeaciones.
        const apiData = await GetPlaneacion(filter);
        const planeacionesFromAPI = apiData.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0);

        // se asigna el valor de planeacionesFromAPI a  setPlaneacionSinFiltro 
        setPlaneacionSinFiltro(planeacionesFromAPI);
        const planeacionesFiltradas = planeacionesFromAPI.filter(planeaciones => planeaciones.enPlanProduccion === false &&
            (planeaciones.fechaDePlaneacion >= fechainicial) && (planeaciones.fechaDePlaneacion <= fechafinal));
        //Se asigna el número de registro a las planeaciones filtradas
        var num = 0;
        await Promise.all(planeacionesFiltradas.map(async planeacion => {
            planeacion.registro = num;
            num++;

            return planeacion;
        }));
        setPlaneacionesFiltradas(planeacionesFiltradas);
        busquedaPlaneacion(planeacionesFiltradas, currentPagePlaneacion, fechaPBusqueda)
        setPCargando(false);

        return planeacionesFromAPI;
    }

    //Obtiene los datos guardados de los planes de producción
    async function fetchPlanProduccion(fechainicial, fechafinal) {
        //Filtro por planeación activa        
        setCargando(true);
        await datosPlanProduccion(fechainicial, fechafinal);
        setCargando(false);

    }
    //Obtiene los datos guardados de los planes de producción
    async function datosPlanProduccion(fechainicial, fechafinal) {
        //Filtro por planeación activa        
        setInputList([]);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaDePlaneacion: {
                    ge: fechainicial
                }
            },
            {
                fechaDePlaneacion: {
                    le: fechafinal
                }
            }]
        }

        //Se obtienen los datos del plan de producción
        const apiData = await GetPProduccionGeneral(filter);

        //Se obtienen los datos del plan de producción
        //const apiData = await GetPProduccion(filter);
        const pProduccionFromAPI = apiData.length > 1 ?
            apiData.sort((a, b) => a.fechaDePlaneacion < b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion > b.fechaDePlaneacion ? -1 : 0) : apiData;
        setPProduccionSinFiltro(pProduccionFromAPI);
        await busquedaPProduccion(pProduccionFromAPI, currentPagePProduccion, fechaPPBusqueda, vistaNumeroParte);

    }
    //Obtiene los datos guardados de Reciba
    async function fetchReciba() {
        setCargando1(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasenAlmacen: {
                        gt: 0,
                    },
                },]
        }

        //Se obtienen los datos de los seriales de la reciba
        const apiData = await GetRecibaSerialesMP(filter);
        const recibaFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

        busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        return recibaFromAPI;
    }

    //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
    function obtenerUltimaUbicaciont(ubicacion) {
        var uUbicacion = "";
        var uLocacion = "";
        var uCantidad = "";
        var uEspacio = "";
        return <>
            <Table className="bordersubtabla">
                <Thead>
                    <Tr>
                        <Th className="subtablah bordersubtabla">Ubic.</Th>
                        <Th className="subtablah bordersubtabla">Loc.</Th>
                        <Th className="subtablah bordersubtabla">Pzs</Th>
                        <Th className="subtablah bordersubtabla">Espacio</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {ubicacion && (
                        <>
                            {ubicacion.map(x => (
                                uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', ''),
                                uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                                uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', ''),
                                uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', ''),
                                <Tr>
                                    <Td className="bordersubtabla">{uUbicacion}</Td>
                                    <Td className="bordersubtabla">{uLocacion}</Td>
                                    <Td className={uLocacion ? "bordersubtabla" : "margintopmobil20px bordersubtabla"}>{uCantidad}</Td>
                                    <Td className="bordersubtabla">{uEspacio}</Td>
                                </Tr>

                            ))}
                        </>)}
                </Tbody>
            </Table>
        </>
    }
    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage, vistaUltimoAP);
    };
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
    };
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage, vistaUltimoAP);
    };
    function onSearchFechaPProduccion(e) {
        setAVisible(false);
        setFechaPPBusqueda(e.target.value);
        //busquedaPProduccion(pProduccionSinFiltro, currentPagePProduccion, e.target.value, vistaNumeroParte)
        fetchPlanProduccion(e.target.value, e.target.value);
    };
    function clicBuscarporFecha(e) {
        setAVisible(false);
        setBuscarporFecha(!buscarporFecha);
        if (!buscarporFecha === false) {
            if (fechaPPBusqueda !== "") {
                setFechaPPBusqueda("");
                //busquedaPProduccion(pProduccionSinFiltro, currentPagePProduccion, "", vistaNumeroParte)
                fetchPlanProduccion(rfechaini, rfechafin);
            }
        }
    };
    //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
    function obtenerUltimaUbicacionPlaneacion(ubicacion) {
        var locaciones = "";
        var locacion = "";
        if (ubicacion) {
            ubicacion.map(x => (
                locacion = "",
                locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                locaciones = locacion === "" ? locaciones : locaciones === "" ? locacion : locaciones + ", " + locacion
            ));
        }
        return locaciones;
    }
    function handleRemoveClick(index, list) {
        if (!editar || !list[index].id)
            list.splice(index, 1);
        else
            list[index].activo = false;

        //FaltanDatosPProduccion(list);
        SumarRacksProduccion(list);
        return list;
    };
    function cancelarpProduccion() {
        fetchReciba();
        //fetchPlaneaciones(rpfechaini, rpfechafin);
        fetchPlanProduccion(rfechaini, rfechafin);
        setEditar(false);
        toggle1('1');
        setFechaPlaneacion("");
    };
    function SumarRacksProduccion(list) {
        var racks = 0;
        var ciclos = 0;
        var cargadas = 0;
        var pintadas = 0;
        var inspeccionadas = 0;
        var arecuperacion = 0;
        var aembarcar = 0;

        list.map((pproduccion, i) => {
            if (pproduccion.activo) {
                if (pproduccion.racks > 0) {
                    racks += parseFloat(pproduccion.racks);
                    ciclos += parseFloat(pproduccion.ciclos);
                    cargadas += (parseFloat(pproduccion.piezasenCarga ? pproduccion.piezasenCarga : 0) +
                        parseFloat(pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0));
                    pintadas += parseFloat(pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0);
                    inspeccionadas += parseFloat(pproduccion.piezasInspeccion ? pproduccion.piezasInspeccion : 0);
                    arecuperacion += parseFloat(pproduccion.piezasTRecuperacion ? pproduccion.piezasTRecuperacion : 0);
                    aembarcar += parseFloat(pproduccion.piezasPintadas ? pproduccion.piezasPintadas : 0);
                    return pproduccion;
                };
            };
        });
        setSumProduccionp(racks.toFixed(2) + " RACKS " + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN");
        setSumICiclos(ciclos);
        setSumPiezasPP((cargadas > 0 ? (" CARGADAS " + cargadas) : "") + (pintadas > 0 ? (" PINTADAS " + pintadas) : "") +
            (inspeccionadas > 0 ? (", PIEZAS INSPECCIONADAS " + inspeccionadas) : "") + (arecuperacion > 0 ? (" RECUPERACION " + arecuperacion) : "")
            + (aembarcar > 0 ? (" A EMBARCAR " + aembarcar) : ""));
    };

    // handle input change
    function handleInputChange(e, index, list) {
        const { name, value } = e.target;
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            list[index][name] = value;
        }
        if (e.target.name === "racks") {
            SumarRacksProduccion(list);
        }
        if (name === "cantidadPiezas" && list[index].piezasXRack > 0) {
            list[index].racks = value > 0 ? (parseFloat(value) / parseFloat(list[index].piezasXRack ? list[index].piezasXRack : 0)).toFixed(2) : 0;
        }
        //FaltanDatosPProduccion(list);
        return list
    };
    function clicEliminar() {
        setModal(!modal);
    };
    async function clicFinalizarPP() {
        //Se revisa si se recuerda que la finalización de plan de producción es por la tarde.
        const fechaPlanProduccion = pProduccion[0].fechaDePlaneacion;
        const hoy = Moment(new Date()).format("YYYY-MM-DD");
        const hora = Moment(new Date()).format("HH:mm");
        if (hoy > fechaPlanProduccion) {
            setAceptarFinalizar(true);
        } else {
            if (hora >= "16:30") {
                setAceptarFinalizar(true);

            } else {
                setAceptarFinalizar(false);
            }

        }
        setDHRegresaraAlmacen(true);
        setRegresaraAlmacen(false);
        await fetchPlanProduccion(rfechaini, rfechafin);
        setModal2(!modal2);
    }
    async function clicAdddeAlmacen(recibap) {
        setBloquearAgregado(true);
        /*const recibaAnterior = await recibaFiltrado.filter(reciba => reciba.numerodeParte === recibap.numerodeParte &&
            reciba.fechaDeReciba < recibap.fechaDeReciba && reciba.cantidadPlaneada < reciba.piezasenAlmacen
            && recibap.autNoFIFO !== "Aceptada")
        setRPANOFIFO(recibap);
        if (recibaAnterior.length) {
            setModal3(!modal3)
        } else {*/
        const datoRepetido = await inputList.filter(datosPProduccion => datosPProduccion.recibaSerialID === recibap.recibaSerialID);
        var lista = [...inputList];
        if (!datoRepetido[0]) {
            const productosID = await GetProductosID(recibap.productoID);
            const cantidadPiezasD = recibap.piezasenAlmacen - recibap.cantidadPlaneada;
            const piezasRack = productosID.piezasXRack ? productosID.piezasXRack : recibap.piezasXRack;
            setModificados(productosID);
            lista.push({
                fechaDePlaneacion: fechaPlaneacion, numero: 0, recibaSerialID: recibap.recibaSerialID, PlaneacionID: '', clienteID: recibap.clienteID,
                productoID: recibap.productoID, cliente: recibap.cliente, numerodeParte: recibap.numerodeParte,
                descripcion: recibap.descripcion, serial: recibap.serial, serialRecibaBTI: recibap.serialRecibaBTI,
                locacion: obtenerUltimaUbicacionPlaneacion(recibap.ultimaUbicacion), piezasXRack: piezasRack,
                cantidadPiezas: cantidadPiezasD, prioridad: inputList.length + 1, divisa: recibap.divisa, recibaSerialMPID: recibap.id,
                racks: piezasRack ? piezasRack > 0 ? (parseFloat(cantidadPiezasD) / parseFloat(piezasRack)).toFixed(2) : '' : '', ciclos: '1',
                orden: 0, desdeAlmacen: true, activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: '', cantidadOriginal: 0,
                cantidadDisponible: cantidadPiezasD, racksOriginal: 0, precioUnitario: recibap.precioUnitario,
                cantidadPlaneadaOriginal: !recibap.cantidadPlaneada ? 0 : recibap.cantidadPlaneada, prioridadOriginal: 0,
                ppracksOriginal: "", materialEnCantidadOriginal: "", ciclosOriginal: "", materialEn: recibap.materialEn,
                materialEnCantidad: ((cantidadPiezasD) / (recibap.piezasenAlmacen / recibap.materialEnCantidad)),
            })
            recibaSinFiltro[recibap.registro].cantidadPlaneada = recibaSinFiltro[recibap.registro].cantidadPlaneada + recibap.piezasenAlmacen;
        } else {
            datoRepetido[0].cantidadPiezas = parseInt(datoRepetido[0].cantidadPiezas) + (recibap.cantidadRecibida - recibap.cantidadPlaneada);
            recibaSinFiltro[recibap.registro].cantidadPlaneada = parseInt(recibaSinFiltro[recibap.registro].cantidadPlaneada) + (recibap.cantidadRecibida - recibap.cantidadPlaneada);
            datoRepetido[0].cantidadDisponible = datoRepetido[0].cantidadPiezas;
        }

        const recibasf = recibaSinFiltro;
        busqueda(recibasf, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        setInputList(lista);
        //}
        setBloquearAgregado(false);
    };
    function clicAdddePlaneacion(planeacionp) {
        var lista = [...inputList];
        lista.push({
            fechaDePlaneacion: fechaPlaneacion, numero: 0, PlaneacionID: planeacionp.id, numeroPlaneacion: planeacionp.numero, recibaSerialID: planeacionp.recibaSerialID,
            clienteID: planeacionp.clienteID,
            productoID: planeacionp.productoID, cliente: planeacionp.cliente, numerodeParte: planeacionp.numerodeParte,
            descripcion: planeacionp.descripcion, serial: planeacionp.serial, serialRecibaBTI: planeacionp.serialRecibaBTI, locacion: planeacionp.locacion,
            cantidadPiezas: planeacionp.cantidadPiezas - planeacionp.cantidadPlanProduccion, prioridad: planeacionp.prioridad,
            materialEnCantidad: planeacionp.materialEnCantidad, divisa: planeacionp.divisa, precioUnitario: planeacionp.precioUnitario,
            racks: planeacionp.racks, ciclos: planeacionp.ciclos, activo: true, racksOriginal: planeacionp.racks, materialEn: planeacionp.materialEn,
            Reg_Ins_Usuario: '', Reg_Mod_Usuario: '', cantidadOriginal: 0, cantidadDisponible: planeacionp.cantidadPiezas - planeacionp.cantidadPlanProduccion,
            cantidadPlaneadaOriginal: !planeacionp.cantidadPlanProduccion ? 0 : planeacionp.cantidadPlanProduccion, desdeAlmacen: false, prioridadOriginal: 0,
            ppracksOriginal: "", materialEnCantidadOriginal: "", ciclosOriginal: "",
        })

        planeacionesFiltradas[planeacionp.registro].cantidadPlanProduccion = planeacionp.cantidadPiezas;
        const planeacionsf = planeacionesFiltradas;
        busquedaPlaneacion(planeacionsf, currentPagePlaneacion, fechaPBusqueda)
        setInputList(lista);
    };
    async function clicEditar() {
        setAVisible(false);
        setCargando(true);
        if (pProduccion.length) {
            var lista = [];
            await Promise.all(pProduccion.map(async (pproduccione, i) => {
                //Se revisa si se trata de registros atrasados, si es así, se busca y asigna el id de la planeación que le corresponde.                                
                //Se agrega a la lista el valor de los datos del plan deproducción para editarlos
                var oCantidadDisponible = pproduccione.cantidadPiezas;
                if (pproduccione.recibaSerialID && pproduccione.desdeAlmacen === true) {
                    var listr = await GetRecibaSerialesID(pproduccione.recibaSerialID);
                    if (listr.id) {
                        oCantidadDisponible = ((oCantidadDisponible + listr.piezasenAlmacen) - (listr.cantidadPlaneada ? listr.cantidadPlaneada : 0)) > 0 ?
                            ((oCantidadDisponible + listr.piezasenAlmacen) - (listr.cantidadPlaneada ? listr.cantidadPlaneada : 0)) : pproduccione.cantidadPiezas;
                    }
                }
                lista.push({
                    id: pproduccione.id, fechaDePlaneacion: pproduccione.fechaDePlaneacion, numero: pproduccione.numero,
                    PlaneacionID: pproduccione.PlaneacionID, numeroPlaneacion: pproduccione.numeroPlaneacion, recibaSerialID: pproduccione.recibaSerialID, serial: pproduccione.serial,
                    serialRecibaBTI: pproduccione.serialRecibaBTI, locacion: pproduccione.locacion, clienteID: pproduccione.clienteID, productoID: pproduccione.productoID, cliente: pproduccione.cliente,
                    numerodeParte: pproduccione.numerodeParte, descripcion: pproduccione.descripcion, prioridad: pproduccione.prioridad,
                    cantidadPiezas: pproduccione.cantidadPiezas, racks: pproduccione.racks, desdeAlmacen: pproduccione.desdeAlmacen, materialEnCantidad: pproduccione.materialEnCantidad,
                    racksOriginal: pproduccione.racksOriginal, ciclos: pproduccione.ciclos, activo: pproduccione.activo, Reg_Ins_Usuario: pproduccione.Reg_Ins_Usuario,
                    Reg_Mod_Usuario: pproduccione.Reg_Mod_Usuario, cantidadOriginal: pproduccione.cantidadPiezas, piezasPintadas: pproduccione.piezasPintadas,
                    cantidadDisponible: oCantidadDisponible, updatedAt: pproduccione.updatedAt,
                    piezasCargadas: ((pproduccione.piezasenCarga ? pproduccione.piezasenCarga : 0) + (pproduccione.piezasenPintado ? pproduccione.piezasenPintado : 0)) > 0 ? true : false,
                    transferido: pproduccione.FechaTransferencia ? true : false, atrasado: pproduccione.atrasado, prioridadOriginal: pproduccione.prioridad,
                    ppracksOriginal: pproduccione.racks, materialEnCantidadOriginal: pproduccione.materialEnCantidad, ciclosOriginal: pproduccione.ciclos,
                })
                //(pproduccione.piezasenCarga ? pproduccione.piezasenCarga : 0) + (pproduccione.piezasenPintado ? pproduccione.piezasenPintado : 0)
            }));
            setNumeroP(pProduccion[0].numero);
            setInputList(lista);
            setFechaPlaneacion(pProduccion[0].fechaDePlaneacion);
            setEditar(true);
            //setFaltanDatos(false);
            SumarRacksProduccion(lista);
            toggle1("4");
        }
        setAVisible(false);
        setCargando(false);
    };
    function clicNuevaPlaneacion(tab) {
        setFechaPlaneacion("");
        setInputList([]);
        setEditar(false);
        toggle1(tab);
    };
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaPP(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "Irfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);

        fetchPlanProduccion(fechaini, fechafin);

    }
    //Revisa cambios en la fecha de búsqueda de planeación
    function onChangesRPFecha(e) {
        e.persist()
        var fechafin = rpfechafin;
        var fechaini = rpfechaini;
        if (e.target.name === "fechaPlaneacionesINI") {
            fechaini = Moment(e.target.value).format("YYYY-MM-DD");
        } else {
            fechafin = Moment(e.target.value).format("YYYY-MM-DD");
        }
        setRPfechaini(fechaini);
        setRPfechafin(fechafin);
        //fetchPlaneaciones(fechaini, fechafin);

    }
    //Al cambiar la fecha del día al que se pasarán los registros al finalizar el plan de producción 
    function onChangesfechaPPS(e) {
        e.persist()
        if (Moment(e.target.value).format("YYYY-MM-DD") >= Moment(new Date()).format("YYYY-MM-DD"))
            setFechaPlaneacionS(Moment(e.target.value).format("YYYY-MM-DD"));
    }
    function onChangesFPPTodo(lista, i, e) {
        //Si i=-1 quiere decir que se eligió la opción de seleccionar todo.
        if (i === -1) {
            lista.map(pProduccion => {
                if (e.target.checked === true) {
                    pProduccion.seleccionada = e.target.checked;
                    if (regresaraAlmacen === true) {
                        pProduccion.regresarMaterial = true;
                    }
                } else {
                    pProduccion.seleccionada = false;
                    pProduccion.regresarMaterial = false;
                }
                return pProduccion
            });
        } else {//Si i es diferente a -1, quiere decir que se seleccionó un checkbox en particular
            if (lista[i].seleccionada === false || !lista[i].seleccionada) {
                lista[i].seleccionada = true
                if (regresaraAlmacen === true) {
                    lista[i].regresarMaterial = true;
                }
            } else {
                lista[i].seleccionada = false
                lista[i].regresarMaterial = false;
            }
        }
        //Se revisa si deshabilitar o no el botón de regresar a almacén
        const cargado = lista.filter(pProduccion => pProduccion.seleccionada === true &&
            parseInt(pProduccion.piezasenCarga ? pProduccion.piezasenCarga : 0) === 0 &&
            parseInt(pProduccion.piezasenPintado ? pProduccion.piezasenPintado : 0) === 0);
        //Se dermina qué valor ponerle a la variable  que determina si deshabilitar o no el botón de regresar a almacén        
        const desHabilitarRegresarMaterial = cargado.length > 0 ? false : true;

        setDHRegresaraAlmacen(desHabilitarRegresarMaterial);
        if (desHabilitarRegresarMaterial === true) {
            setRegresaraAlmacen(false);
        }
        return lista;
    }
    function onChangesRegresarMaterial(lista, e) {
        lista.map(pProduccion => {
            setRegresaraAlmacen(e.target.checked);
            const cargado = parseInt(pProduccion.piezasenCarga ? pProduccion.piezasenCarga : 0) +
                parseInt(pProduccion.piezasenPintado ? pProduccion.piezasenPintado : 0)
            if (e.target.checked === true && pProduccion.seleccionada === true && cargado === 0) {
                pProduccion.regresarMaterial = e.target.checked;
            } else {
                pProduccion.regresarMaterial = false;
            }
            return pProduccion
        });
        return lista;
    }
    async function aceptarEliminar() {
        setAVisible(false);
        setCargando(true);
        setModal(!modal);
        try {
            var pConcurrencia = false;
            var carga = false;
            var idNoencontrado = false;
            //Se obtienen los datos del plan de producción por número para revisar la concurrencia
            let cfilter = {
                numero: {
                    eq: pProduccion[0].numero
                }
            }
            //Se obtienen los datos del plan de producción
            const pProduccionFromAPI = await GetPProduccion(cfilter);
            //Se hacen validaciones de datos            
            await Promise.all(pProduccion.map(async pproduccion => {
                //Se revisa la concurrencia en plan de producción
                const pproduccionC = pProduccionFromAPI.filter(cpproduccion => cpproduccion.id === pproduccion.id);
                if (pproduccionC.length < 1) {
                    pConcurrencia = true;
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en plan de producción (1)");
                } else {
                    if (pproduccion.updatedAt !== pproduccionC[0].updatedAt) {
                        pConcurrencia = true;
                        setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en plan de producción (1)");
                    }
                }
                //Se revisa concurrencia en recibaSeriales
                if (pproduccion.desdeAlmacen === true) {
                    //Se obtinen los datos                    
                    const recibaDatosAc = await await GetRecibaSerialesID(pproduccion.recibaSerialID);
                    //Se revisa la concurrencia
                    if (recibaDatosAc.length < 1) { //Si no se obtuvieron los datos, se marca como concurrencia
                        pConcurrencia = true;
                    } else { //Si se encontraron datos
                        //Se filtra recibaSinFiltro para obtener el dato de reciba con el que se está trabajando
                        const recibaDatos = recibaSinFiltro.filter(recibad => recibad.id === pproduccion.recibaSerialID)
                        if (recibaDatos.length < 1) //Si no encuentra el dato, se marca como concurrencia
                        {
                            pConcurrencia = true;
                            setMensajeAlert("No fue posible realizar la operación: existe concurrencia, en Reciba (1)");
                        }
                        else { //Si se encuentra el dato, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos
                            if (recibaDatosAc.updatedAt !== recibaDatos[0].updatedAt) {
                                pConcurrencia = true;
                                setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en Reciba (2)");
                            }
                        }

                    }

                }
                //Se revisa si el material ya está en carga o se transfirió a otra fecha.
                if (pproduccion.piezasenCarga > 0 || pproduccion.piezasenPintado > 0 || pproduccionC[0].FechaTransferencia)
                    carga = true;

            }));
            //Si no se encontró algún id de planeación para los registros atrasados del plan de producción, no se procede con el proceso
            if (idNoencontrado === true) {
                window.scrollTo(0, 0);
                setMensajeAlert("Problemas al determinar datos: favor de reportarlo al área de sistemas");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si uno o más registros del plan de producción ya tienen registro en carga y/o ya se transfirieron al plan de producción de otro día,
            //no se procede con el proceso        
            if (carga) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: uno o más registros del plan de producción ya tienen registro en carga y/o ya se transfirieron al plan de producción de otro día");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en pProduccion
            if (pConcurrencia === false) {
                await Promise.all(pProduccion.map(async (pProduccionl, i) => {
                    if (pProduccionl.desdeAlmacen === true) {
                        const recibaFromAPI = await GetRecibaSerialesID(pProduccionl.recibaSerialID);
                        if (recibaFromAPI.id) {
                            delete recibaFromAPI.createdAt;
                            delete recibaFromAPI.updatedAt;
                            delete recibaFromAPI.__typename;
                            recibaFromAPI.Reg_Mod_Usuario = userName;
                            recibaFromAPI.cantidadPlaneada = (recibaFromAPI.cantidadPlaneada - pProduccionl.cantidadPiezas) < 0 ? 0 :
                                recibaFromAPI.cantidadPlaneada - pProduccionl.cantidadPiezas;
                            let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });

                            const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                            if (recibaFromAPI.recibaSerialMPID) {
                                delete recibaFromAPI.recibaSerialMPID;
                                recibaFromAPI.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                                await API.graphql({
                                    query: updateRecibaSerialesMP,
                                    variables: { input: { ...recibaFromAPI, id: recibaSerialMPID } },
                                });
                            }
                            return recibaFromAPI;
                        };
                    }
                    delete pProduccionl.paginacion;
                    delete pProduccionl.color;
                    delete pProduccionl.createdAt;
                    delete pProduccionl.updatedAt;
                    delete pProduccionl.__typename;
                    delete pProduccionl.cantidadDisponible;
                    delete pProduccionl.completo;
                    delete pProduccionl.piezasATransferir;
                    delete pProduccionl.piezasCompletas;
                    delete pProduccionl.piezasCargadas;
                    delete pProduccionl.transferido;
                    pProduccionl.Reg_Mod_Usuario = userName;
                    pProduccionl.activo = false;
                    setMensajeAlert("Error al actualizar los datos del plan de producción " + JSON.stringify(pProduccionl));
                    await API.graphql({ query: updatePProduccion, variables: { input: pProduccionl } });

                }));
                setMensajeAlert("Operación exitosa");
                setColor("primary");
                setCargando(false);
                setAVisible(true);
                //fetchPlaneaciones(rpfechaini, rpfechafin);
                fetchPlanProduccion(rfechaini, rfechafin);
                fetchReciba();
                toggle1('1');
            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizó la información, favor de revisar los datos y " +
                    " volver a intentarlo");*/
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlanProduccion(rfechaini, rfechafin);
            }

        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    async function aceptarFinalizarPP() {
        setAVisible(false);
        setCargando(true);
        setModal2(!modal2);
        try {
            var pConcurrencia = false;
            //Se obtienen los datos del plan de producción por número para revisar la concurrencia            
            const pProduccionFromAPI = await GetPProduccion({ numero: { eq: pProduccion[0].numero } });
            const incompletoSeleccionado = pProduccionIncompleta.filter(pproduccionI => pproduccionI.seleccionada === true);
            await Promise.all(incompletoSeleccionado.map(async pproduccion => {
                const pproduccionC = pProduccionFromAPI.filter(cpproduccion => cpproduccion.id === pproduccion.id);
                if (pproduccionC.length < 1) {
                    setMensajeAlert("Problema de concurrencia (1) con el serial " + pproduccion.serialRecibaBTI + " Favor de reintar la operación")
                    pConcurrencia = true;
                } else {
                    if (pproduccion.completo === false) {
                        if (pproduccion.updatedAt !== pproduccionC[0].updatedAt) {
                            setMensajeAlert("Problema de concurrencia (2) con el serial " + pproduccion.serialRecibaBTI + " Favor de reintar la operación");
                            pConcurrencia = true;
                        }
                    }
                }
            }));
            //Si no existe concurrencia, se actualizan los datos en pProduccion y se agregan los registros con trabajo incompleto en producción
            // a la fecha especificada 
            if (pConcurrencia === false) {
                //Variables requeridas                
                var numeroPlaneacion = 1;
                var numeroUPP = 1;
                var numeroProduccion = 1;
                var pproduccionGID = {};
                var pproduccionIDS = [];
                var rSerialesIDS = [];
                //Se revisa si existe una planeación en la fecha especificada.
                let filterp = {
                    and: [
                        {
                            fechaDePlaneacion: {
                                eq: fechaPlaneacionS
                            }
                        },
                        {
                            activo: {
                                eq: true
                            }
                        }
                    ]
                }
                //Se revisa si existe un plan de producción en la fecha especificada.                                
                const apiDataF = await GetPProduccionGeneral(filterp);
                //Si no existe, se crea un nuevo plan de producción, creando el nuevo número en PProduccionUltimoNumero .
                const produccionnRegistros = await apiDataF.length ? apiDataF.length : 0;
                if (produccionnRegistros === 0) {
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUPP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUPP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUPP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }
                    numeroProduccion = numeroUPP;
                    //Se crea el registro de la plan de producción general
                    setMensajeAlert("Problemas al guardar la planeación general 1");
                    let resulppg = await API.graphql({
                        query: createPProduccionGeneral, variables: {
                            input: {
                                fechaDePlaneacion: fechaPlaneacionS,
                                numero: numeroUPP,
                                espacioVacio: 0,
                                activo: true,
                                Reg_Ins_Usuario: userName
                            }
                        }
                    });
                    pproduccionGID = resulppg.data.createPProduccionGeneral;

                } else { //Si existe, se obtiene el número de plan de producción
                    numeroProduccion = apiDataF[0].numero;
                    pproduccionGID = apiDataF[0];
                }
                //Si ya existe, se agregan los registros al plan de producción de la fecha especificada.

                //Se actualizan los datos en el plan de producción original, se agregan ala planeación y plan de producción que corresponde.                
                await Promise.all(incompletoSeleccionado.map(async (pProduccionl, i) => {
                    if (pProduccionl.completo === false) {
                        //Se agregan los datos al plan de producción que corresponde
                        //Se agregan los registros a la planeación de la fecha especificada. 
                        if (!pProduccionl.regresarMaterial || pProduccionl.regresarMaterial === false) {

                            //Se agregan los registros al plan de producción de la fecha especificada.
                            const npProduccion = {};
                            npProduccion.fechaDePlaneacion = fechaPlaneacionS;
                            npProduccion.numero = numeroProduccion;
                            npProduccion.numeroPlaneacion = numeroPlaneacion;
                            npProduccion.recibaSerialID = pProduccionl.recibaSerialID;
                            npProduccion.planeacionIDAnterior = pProduccionl.PlaneacionID;
                            npProduccion.clienteID = pProduccionl.clienteID;
                            npProduccion.productoID = pProduccionl.productoID;
                            npProduccion.cliente = pProduccionl.cliente;
                            npProduccion.numerodeParte = pProduccionl.numerodeParte;
                            npProduccion.descripcion = pProduccionl.descripcion;
                            npProduccion.serial = pProduccionl.serial;
                            npProduccion.serialRecibaBTI = pProduccionl.serialRecibaBTI;
                            npProduccion.locacion = pProduccionl.locacion;
                            npProduccion.cantidadPiezas = pProduccionl.piezasATransferir;
                            npProduccion.prioridad = 1;
                            npProduccion.racks = pProduccionl.racks;
                            npProduccion.ciclos = pProduccionl.ciclos;
                            npProduccion.orden = pProduccionl.orden;
                            npProduccion.materialEn = pProduccionl.materialEn;
                            npProduccion.materialEnCantidad = pProduccionl.materialEnCantidad;
                            npProduccion.precioUnitario = pProduccionl.precioUnitario;
                            npProduccion.divisa = pProduccionl.divisa;
                            npProduccion.desdeAlmacen = false;//pProduccionl.desdeAlmacen;
                            npProduccion.piezasenCarga = pProduccionl.piezasenCarga;
                            npProduccion.piezasenPintado = pProduccionl.piezasCompletas ? parseInt(pProduccionl.piezasenPintado) - parseInt(pProduccionl.piezasCompletas) : pProduccionl.piezasenPintado;
                            npProduccion.piezasInspeccion = ((pProduccionl.piezasCompletas) && (pProduccionl.piezasInspeccion ? pProduccionl.piezasInspeccion : 0) > 0) ?
                                (parseInt(pProduccionl.piezasInspeccion ? pProduccionl.piezasInspeccion : 0) +
                                    parseInt(pProduccionl.piezasTRecuperacion ? pProduccionl.piezasTRecuperacion : 0)) -
                                parseInt(pProduccionl.piezasCompletas) : pProduccionl.piezasInspeccion;

                            // if (pProduccionl.piezasIRecuperacion) { npProduccion.piezasIRecuperacion = pProduccionl.piezasIRecuperacion }
                            //if (pProduccionl.piezasCRecuperacion) { npProduccion.piezasCRecuperacion = pProduccionl.piezasCRecuperacion }
                            //if (pProduccionl.piezasTRecuperacion) { npProduccion.piezasTRecuperacion = pProduccionl.piezasTRecuperacion }
                            //if (pProduccionl.piezasRecuperadas) { npProduccion.piezasRecuperadas = pProduccionl.piezasRecuperadas }
                            // if (pProduccionl.piezasNRecuperadas) { npProduccion.piezasNRecuperadas = pProduccionl.piezasNRecuperadas }
                            if (pProduccionl.registroCarga) { npProduccion.registroCarga = pProduccionl.registroCarga }
                            if (pProduccionl.registroPintado) { npProduccion.registroPintado = pProduccionl.registroPintado }
                            if (pProduccionl.registroInspeccionF) { npProduccion.registroInspeccionF = pProduccionl.registroInspeccionF }
                            if (pProduccionl.cargaFechaHora) { npProduccion.cargaFechaHora = pProduccionl.cargaFechaHora }
                            if (pProduccionl.pintadoFechaHora) { npProduccion.pintadoFechaHora = pProduccionl.pintadoFechaHora }
                            if (pProduccionl.inspeccionesFechaHora) { npProduccion.inspeccionesFechaHora = pProduccionl.inspeccionesFechaHora }

                            npProduccion.piezasenCargaAnterior = !npProduccion.piezasenCargaAnterior ?
                                parseInt(pProduccionl.piezasenCarga ? pProduccionl.piezasenCarga : 0) + parseInt(pProduccionl.piezasenPintado ? pProduccionl.piezasenPintado : 0) :
                                npProduccion.piezasenCargaAnterior + parseInt(pProduccionl.piezasenCarga ? pProduccionl.piezasenCarga : 0);
                            npProduccion.piezasenPintadoAnterior = parseInt(pProduccionl.piezasenPintado ? pProduccionl.piezasenPintado : 0)
                            npProduccion.piezasInspeccionAnterior = parseInt(pProduccionl.piezasInspeccion ? pProduccionl.piezasInspeccion : 0)


                            npProduccion.MesasInspeccion = pProduccionl.MesasInspeccion;
                            npProduccion.racksOriginal = pProduccionl.racksOriginal;
                            npProduccion.activo = true;
                            npProduccion.atrasado = true;
                            npProduccion.fechaAnterior = pProduccionl.fechaDePlaneacion;
                            npProduccion.pProduccionIDAnterior = pProduccionl.id;
                            npProduccion.Reg_Ins_Usuario = userName;
                            //Datos de carga
                            if (pProduccionl.numeroCarga) { npProduccion.numeroCarga = pProduccionl.numeroCarga; }
                            if (pProduccionl.ultimoRack) { npProduccion.ultimoRack = pProduccionl.ultimoRack; }
                            if (pProduccionl.piezasenCarga1) { npProduccion.piezasenCarga1 = pProduccionl.piezasenCarga1; }
                            if (pProduccionl.numeroRackCarga1) { npProduccion.numeroRackCarga1 = pProduccionl.numeroRackCarga1; }
                            if (pProduccionl.cicloCarga1) { npProduccion.cicloCarga1 = pProduccionl.cicloCarga1; }
                            if (pProduccionl.piezasenCarga2) { npProduccion.piezasenCarga2 = pProduccionl.piezasenCarga2; }
                            if (pProduccionl.numeroRackCarga2) { npProduccion.numeroRackCarga2 = pProduccionl.numeroRackCarga2; }
                            if (pProduccionl.cicloCarga2) { npProduccion.cicloCarga2 = pProduccionl.cicloCarga2; }
                            if (pProduccionl.piezasenCarga3) { npProduccion.piezasenCarga3 = pProduccionl.piezasenCarga3; }
                            if (pProduccionl.numeroRackCarga3) { npProduccion.numeroRackCarga3 = pProduccionl.numeroRackCarga3; }
                            if (pProduccionl.cicloCarga3) { npProduccion.cicloCarga3 = pProduccionl.cicloCarga3; }
                            if (pProduccionl.piezasenCarga4) { npProduccion.piezasenCarga4 = pProduccionl.piezasenCarga4; }
                            if (pProduccionl.numeroRackCarga4) { npProduccion.numeroRackCarga4 = pProduccionl.numeroRackCarga4; }
                            if (pProduccionl.cicloCarga4) { npProduccion.cicloCarga4 = pProduccionl.cicloCarga4; }
                            if (pProduccionl.piezasenCarga5) { npProduccion.piezasenCarga5 = pProduccionl.piezasenCarga5; }
                            if (pProduccionl.numeroRackCarga5) { npProduccion.numeroRackCarga5 = pProduccionl.numeroRackCarga5; }
                            if (pProduccionl.cicloCarga5) { npProduccion.cicloCarga5 = pProduccionl.cicloCarga5; }
                            if (pProduccionl.piezasenCarga6) { npProduccion.piezasenCarga6 = pProduccionl.piezasenCarga6; }
                            if (pProduccionl.numeroRackCarga6) { npProduccion.numeroRackCarga6 = pProduccionl.numeroRackCarga6; }
                            if (pProduccionl.cicloCarga6) { npProduccion.cicloCarga6 = pProduccionl.cicloCarga6; }
                            if (pProduccionl.piezasenCarga7) { npProduccion.piezasenCarga7 = pProduccionl.piezasenCarga7; }
                            if (pProduccionl.numeroRackCarga7) { npProduccion.numeroRackCarga7 = pProduccionl.numeroRackCarga7; }
                            if (pProduccionl.cicloCarga7) { npProduccion.cicloCarga7 = pProduccionl.cicloCarga7; }
                            if (pProduccionl.piezasenCarga8) { npProduccion.piezasenCarga8 = pProduccionl.piezasenCarga8; }
                            if (pProduccionl.numeroRackCarga8) { npProduccion.numeroRackCarga8 = pProduccionl.numeroRackCarga8; }
                            if (pProduccionl.cicloCarga8) { npProduccion.cicloCarga8 = pProduccionl.cicloCarga8; }
                            if (pProduccionl.piezasenCarga9) { npProduccion.piezasenCarga9 = pProduccionl.piezasenCarga9; }
                            if (pProduccionl.numeroRackCarga9) { npProduccion.numeroRackCarga9 = pProduccionl.numeroRackCarga9; }
                            if (pProduccionl.cicloCarga9) { npProduccion.cicloCarga9 = pProduccionl.cicloCarga9; }
                            if (pProduccionl.piezasenCarga10) { npProduccion.piezasenCarga10 = pProduccionl.piezasenCarga10; }
                            if (pProduccionl.numeroRackCarga10) { npProduccion.numeroRackCarga10 = pProduccionl.numeroRackCarga10; }
                            if (pProduccionl.cicloCarga10) { npProduccion.cicloCarga10 = pProduccionl.cicloCarga10; }
                            if (pProduccionl.piezasenCarga11) { npProduccion.piezasenCarga11 = pProduccionl.piezasenCarga11; }
                            if (pProduccionl.numeroRackCarga11) { npProduccion.numeroRackCarga11 = pProduccionl.numeroRackCarga11; }
                            if (pProduccionl.cicloCarga11) { npProduccion.cicloCarga11 = pProduccionl.cicloCarga11; }
                            if (pProduccionl.piezasenCarga12) { npProduccion.piezasenCarga12 = pProduccionl.piezasenCarga12; }
                            if (pProduccionl.numeroRackCarga12) { npProduccion.numeroRackCarga12 = pProduccionl.numeroRackCarga12; }
                            if (pProduccionl.cicloCarga12) { npProduccion.cicloCarga12 = pProduccionl.cicloCarga12; }
                            if (pProduccionl.piezasenCarga13) { npProduccion.piezasenCarga13 = pProduccionl.piezasenCarga13; }
                            if (pProduccionl.numeroRackCarga13) { npProduccion.numeroRackCarga13 = pProduccionl.numeroRackCarga13; }
                            if (pProduccionl.cicloCarga13) { npProduccion.cicloCarga13 = pProduccionl.cicloCarga13; }
                            if (pProduccionl.piezasenCarga14) { npProduccion.piezasenCarga14 = pProduccionl.piezasenCarga14; }
                            if (pProduccionl.numeroRackCarga14) { npProduccion.numeroRackCarga14 = pProduccionl.numeroRackCarga14; }
                            if (pProduccionl.cicloCarga14) { npProduccion.cicloCarga14 = pProduccionl.cicloCarga14; }
                            if (pProduccionl.piezasenCarga15) { npProduccion.piezasenCarga15 = pProduccionl.piezasenCarga15; }
                            if (pProduccionl.numeroRackCarga15) { npProduccion.numeroRackCarga15 = pProduccionl.numeroRackCarga15; }
                            if (pProduccionl.cicloCarga15) { npProduccion.cicloCarga15 = pProduccionl.cicloCarga15; }
                            if (pProduccionl.piezasenCarga16) { npProduccion.piezasenCarga16 = pProduccionl.piezasenCarga16; }
                            if (pProduccionl.numeroRackCarga16) { npProduccion.numeroRackCarga16 = pProduccionl.numeroRackCarga16; }
                            if (pProduccionl.cicloCarga16) { npProduccion.cicloCarga16 = pProduccionl.cicloCarga16; }
                            //npProduccion.PlaneacionID = planeacionCreada.id;
                            //Se agregan los registros al plan de producción de la fecha especificada.                                                                                                                                                                    
                            setMensajeAlert("Problemas al guardar el plan de producción " + JSON.stringify(npProduccion));//+ JSON.stringify(npProduccion) 
                            let resultPP = await API.graphql({ query: createPProduccion, variables: { input: npProduccion } });
                            pproduccionIDS.push({ id: resultPP.data.createPProduccion.id, nuevo: true, activo: true });
                            rSerialesIDS.push({ id: resultPP.data.createPProduccion.recibaSerialID, nuevo: true, activo: true });
                        } else {
                            //Si se tiene que resgresar el material a almacén , se actualiza la tabla resibaSeriales
                            if (pProduccionl.regresarMaterial === true && pProduccionl.recibaSerialID) {
                                const recibaSerialUP = await GetRecibaSerialesID(pProduccionl.recibaSerialID);
                                delete recibaSerialUP.createdAt;
                                delete recibaSerialUP.updatedAt;
                                delete recibaSerialUP.__typename;
                                recibaSerialUP.Reg_Mod_Usuario = userName;
                                recibaSerialUP.cantidadPlaneada = parseInt(recibaSerialUP.cantidadPlaneada ? recibaSerialUP.cantidadPlaneada : 0) - parseInt(pProduccionl.piezasATransferir ? pProduccionl.piezasATransferir : 0);
                                setMensajeAlert("Problemas al actualizar los datos en RecibaSeriales " + JSON.stringify(recibaSerialUP));
                                let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerialUP } });

                                //Se actualizan los cambios en recibaSerialesMP
                                const recibaSerialMPID = recibaSerialUP.recibaSerialMPID;
                                if (recibaSerialUP.recibaSerialMPID) {
                                    delete recibaSerialUP.recibaSerialMPID;
                                    recibaSerialUP.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                                    await API.graphql({
                                        query: updateRecibaSerialesMP,
                                        variables: { input: { ...recibaSerialUP, id: recibaSerialMPID } },
                                    });
                                }
                                pProduccionl.regresadoAlmacen = true;
                            }

                        }
                        //Datos de planeación y plan de producción
                        pProduccionl.piezasTransferidas = pProduccionl.piezasATransferir;
                        pProduccionl.FechaTransferencia = fechaPlaneacionS;
                        pProduccionl.terminado = true;

                        //Se actualiza el registro en PProduccion                        
                        delete pProduccionl.paginacion;
                        delete pProduccionl.color;
                        delete pProduccionl.createdAt;
                        delete pProduccionl.updatedAt;
                        delete pProduccionl.__typename;
                        delete pProduccionl.cantidadDisponible;
                        delete pProduccionl.completo;
                        delete pProduccionl.piezasATransferir;
                        delete pProduccionl.piezasCompletas;
                        delete pProduccionl.seleccionada;
                        delete pProduccionl.regresarMaterial;
                        pProduccionl.Reg_Mod_Usuario = userName;
                        setMensajeAlert("Problemas al actualizar el plan de producción " + JSON.stringify(pProduccionl));//+ JSON.stringify(pProduccionl)                      
                        await API.graphql({ query: updatePProduccion, variables: { input: pProduccionl } });
                    }
                    return pProduccionl;

                }));

                //Seactualiza el registro general de plan de producción.          
                if (pproduccionGID.id) {
                    setMensajeAlert("Problemas al actualizar el plan de producción general 3: PProducción General " + JSON.stringify(pproduccionGID) +
                        "PProducción ids" + JSON.stringify(pproduccionIDS));

                    const ppgids = pproduccionGID.PProduccionIDS ? pproduccionGID.PProduccionIDS.length > 0 ? pproduccionGID.PProduccionIDS : [] : [];
                    const datosPPINDS = await combinarIDS(ppgids, pproduccionIDS);

                    const rsgids = pproduccionGID.recibaSerialIDS ? pproduccionGID.recibaSerialIDS.length > 0 ? pproduccionGID.recibaSerialIDS : [] : [];
                    const datosRSerialIDS = await combinarIDS(rsgids, rSerialesIDS);

                    setMensajeAlert("Problemas al actualizar el plan de producción general 4 " + JSON.stringify(datosPPINDS));
                    const rPProduccion = {
                        ...pproduccionGID,
                        PProduccionIDS: datosPPINDS,
                        recibaSerialIDS: datosRSerialIDS,
                        Reg_Mod_Usuario: userName
                    };
                    delete rPProduccion.createdAt;
                    delete rPProduccion.updatedAt;
                    delete rPProduccion.__typename;
                    setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                    await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                }

                setMensajeAlert("Operación exitosa");
                setColor("primary");
                setCargando(false);
                setAVisible(true);
                //fetchPlaneaciones(rpfechaini, rpfechafin);
                fetchPlanProduccion(rfechaini, rfechafin);
                fetchReciba();
                setInputList([]);
                toggle1('1');
            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizó la información, favor de revisar los datos y " +
                    " volver a intentarlo");*/
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlanProduccion(rfechaini, rfechafin);
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    async function aceptarRANOFIFO() {
        setModal3(!modal3);
        setAVisible(false);
        setCargando(true);
        try {
            //Se revisa que estén todos los datos
            if (!usuarioAutNoFIFO || !comentariosNoFIFO || !usuarioAutNoFIFO2) {
                window.scrollTo(0, 0);
                setMensajeAlert("Faltan datos, por favor ingresa los motivos para no usar el FIFO y elige a quien autorizará.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si el usuario ingreso los datos requeridos, se procede con las demás validaciones
            var pConcurrencia = false;
            var yaPedido = false;
            //Se obtienen los datos de la reciba por id para revisar la concurrencia                       
            const recibaSFromAPI = await GetRecibaSerialesID(rPANOFIFO.id);
            //Se revisa si existe concurrencia
            if (!recibaSFromAPI.id) {
                pConcurrencia = true;
            } else {
                if (rPANOFIFO.updatedAt !== recibaSFromAPI.updatedAt)
                    pConcurrencia = true;
            }
            //Se revisa si ya se registró en la base de datos una petición para no utilizar el FIFO para el contenedor seleccionado         
            yaPedido = recibaSFromAPI.solNoFIFO ? recibaSFromAPI.solNoFIFO : false;
            if (yaPedido === true) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: Ya se encuentra registrada la solicitud para no usar el FIFO para el material en cuestión.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca que ya se solicitó la autorización solNoFIFO
            if (pConcurrencia === false) {
                //Se marca en Reciba seriales como Solicitada la autorización poniendo solNoFIFO = true
                const datosReciba = recibaSFromAPI;
                delete datosReciba.createdAt;
                delete datosReciba.updatedAt;
                delete datosReciba.__typename;
                datosReciba.solNoFIFO = true;
                datosReciba.solNoFIFOModulo = "Producción";
                datosReciba.solPNoFIFOMotivos = comentariosNoFIFO;
                datosReciba.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar los datos de reciba");
                let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: datosReciba } });

                //Se actualizan los cambios en recibaSerialesMP
                const recibaSerialMPID = datosReciba.recibaSerialMPID;
                if (datosReciba.recibaSerialMPID) {
                    delete datosReciba.recibaSerialMPID;
                    datosReciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                    await API.graphql({
                        query: updateRecibaSerialesMP,
                        variables: { input: { ...datosReciba, id: recibaSerialMPID } },
                    });
                }

                //Tambien se crean dos registros nuevos en la tabla de Autorizaciones
                const fecha = Moment(new Date()).format("YYYY-MM-DD");
                const hora = Moment(new Date()).format("HH:mm");
                const datosAutorizacion = {};
                datosAutorizacion.recibaSerialID = datosReciba.id;
                datosAutorizacion.clienteID = datosReciba.clienteID;
                datosAutorizacion.cliente = datosReciba.cliente;
                datosAutorizacion.productoID = datosReciba.productoID;
                datosAutorizacion.numerodeParte = datosReciba.numerodeParte;
                datosAutorizacion.descripcion = datosReciba.descripcion;
                datosAutorizacion.serial = datosReciba.serial;
                datosAutorizacion.serialRecibaBTI = datosReciba.serialRecibaBTI;
                datosAutorizacion.peticionTipo = "Petición 1. Autorizar no aplicar FIFO";
                datosAutorizacion.peticionModulo = "Producción";
                datosAutorizacion.peticionMotivos = comentariosNoFIFO;
                datosAutorizacion.peticionFecha = fecha;
                datosAutorizacion.peticionHora = hora;
                datosAutorizacion.peticionUsuario = usuariosNC;
                datosAutorizacion.peticionUAutorizar = usuarioAutNoFIFO;
                datosAutorizacion.activo = true;
                datosAutorizacion.cancelado = false;
                datosAutorizacion.Reg_Ins_Usuario = userName;
                //Primera petición de producción
                setMensajeAlert("Problemas al guardar la solicitud de la autorización");//+ JSON.stringify(datosAutorizacion)
                await API.graphql({ query: createAutorizaciones, variables: { input: datosAutorizacion } });
                //Segunda petición de producción
                datosAutorizacion.peticionTipo = "Petición 2. Autorizar no aplicar FIFO";
                datosAutorizacion.peticionUAutorizar = usuarioAutNoFIFO2;
                setMensajeAlert("Problemas al guardar la solicitud de la autorización");//+ JSON.stringify(datosAutorizacion)
                await API.graphql({ query: createAutorizaciones, variables: { input: datosAutorizacion } });

                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa: se requiere llamar por teléfono a " + usuarioAutNoFIFO + " y a " + usuarioAutNoFIFO2 + " e informarles que tienen una autorización pendiente");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                setComentariosNoFIFO("");
                setUsuarioAutNoFIFO("");
                fetchReciba();
                //setInputList([]);
                //toggle1('1');

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizarán los datos de almacén, " +
                    "una vez que se actualicen los datos, se requiere volver a intentarlo.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchReciba();
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    async function cancelarRANOFIFO() {
        setModal3(!modal3);
        setAVisible(false);
        setCargando(true);
        try {
            //Se revisa que estén todos los datos
            if (!comentariosNoFIFO) {
                window.scrollTo(0, 0);
                setMensajeAlert("Faltan datos, por favor ingresa los motivos para cancelar la solicitud.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si el usuario ingreso los datos requeridos, se procede con las demás validaciones
            var pConcurrencia = false;
            var yaPedido = false;
            //Se obtienen los datos de la reciba por id para revisar la concurrencia            
            const recibaSFromAPI = await GetRecibaSerialesID(rPANOFIFO.id);
            //Se revisa si existe concurrencia
            if (!recibaSFromAPI.id) {
                pConcurrencia = true;
            } else {
                if (rPANOFIFO.updatedAt !== recibaSFromAPI.updatedAt)
                    pConcurrencia = true;
            }
            //Se revisa si ya se canceló la solicitud       
            yaPedido = recibaSFromAPI.solNoFIFO ? recibaSFromAPI.solNoFIFO : false;
            if (yaPedido === false) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: Ya se encuentra cancelada la solicitud para no usar el FIFO para el material en cuestión.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca que ya se canceló la solicitó la autorización solNoFIFO
            if (pConcurrencia === false) {
                //Se marca en Reciba seriales como cancelada la solicitud poniendo solNoFIFO = false
                const datosReciba = recibaSFromAPI;
                delete datosReciba.createdAt;
                delete datosReciba.updatedAt;
                delete datosReciba.__typename;
                datosReciba.solNoFIFO = false;
                datosReciba.solNoFIFOModulo = "";
                datosReciba.solPNoFIFOMotivos = "";
                datosReciba.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar los datos de reciba");
                let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: datosReciba } });

                //Se actualizan los cambios en recibaSerialesMP
                const recibaSerialMPID = datosReciba.recibaSerialMPID;
                if (datosReciba.recibaSerialMPID) {
                    delete datosReciba.recibaSerialMPID;
                    datosReciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                    await API.graphql({
                        query: updateRecibaSerialesMP,
                        variables: { input: { ...datosReciba, id: recibaSerialMPID } },
                    });
                }

                let afilter = {
                    and: [{
                        recibaSerialID: {
                            eq: rPANOFIFO.id
                        }
                    },
                    {
                        activo: {
                            eq: true
                        }
                    }
                        ,
                    {
                        cancelado: {
                            eq: false
                        }
                    }
                    ]
                }

                //Se obtienen los datos de las autorizaciones
                var apiDataA = await GetAutorizaciones(afilter);

                //Tambien se cancelan las peticiones de autorización generadas                
                await Promise.all(apiDataA.map(async datosAutorizacion => {
                    delete datosAutorizacion.createdAt;
                    delete datosAutorizacion.updatedAt;
                    delete datosAutorizacion.__typename;
                    datosAutorizacion.cancelado = true;
                    datosAutorizacion.cancelacionComentarios = comentariosNoFIFO;
                    datosAutorizacion.Reg_Mod_Usuario = userName;
                    setMensajeAlert("Problemas al cancelar la solicitud " + JSON.stringify(datosAutorizacion));//+ JSON.stringify(datosAutorizacion)
                    await API.graphql({ query: updateAutorizaciones, variables: { input: datosAutorizacion } });
                }));


                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa: se requiere llamar por teléfono a " + apiDataA[0].peticionUAutorizar + " y a " + apiDataA[1].peticionUAutorizar + " e informarles que se canceló la solicitud en cuestión");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                setComentariosNoFIFO("");
                setUsuarioAutNoFIFO("");
                fetchReciba();
                //setInputList([]);
                //toggle1('1');

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizarán los datos de almacén, " +
                    "una vez que se actualicen los datos, se requiere volver a intentarlo.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchReciba();
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    async function revisarCantidadesValidas(list) {
        var cantidadValida = true;
        list.map(async (planeacion, i) => {
            if ((planeacion.cantidadDisponible) < planeacion.cantidadPiezas ||
                planeacion.cantidadPiezas < planeacion.piezasPintadas) {
                //(planeacion.racksOriginal && planeacion.racksOriginal < planeacion.racks) ||
                cantidadValida = false;
            };
        });
        return cantidadValida;
    };
    function FaltanDatosPProduccion(list) {
        var fdatos = false;
        list.map((pProduccion, i) => {
            if (pProduccion.activo) {
                if (!pProduccion.productoID || !pProduccion.cliente || !pProduccion.numerodeParte ||
                    !pProduccion.cantidadPiezas || !pProduccion.racks || !pProduccion.ciclos) {
                    fdatos = true;
                };
            };
        });
        return fdatos;
        //setFaltanDatos(fdatos);
    };
    async function validacionesPProduccion(list) {
        var fdatos = false;
        var cantidadValida = true;
        var iDSActivos = [];
        var recibaSerialIDS = [];
        list.map((pProduccion, i) => {
            //Se revisa si faltan datos
            if (pProduccion.activo) {
                if (!pProduccion.productoID || !pProduccion.cliente || !pProduccion.numerodeParte ||
                    !pProduccion.cantidadPiezas || !pProduccion.racks || !pProduccion.ciclos) {
                    fdatos = true;
                };
            };
            //Se revisa si hay cantidades no válidas
            if ((pProduccion.cantidadDisponible) < pProduccion.cantidadPiezas ||
                pProduccion.cantidadPiezas < pProduccion.piezasPintadas) {
                cantidadValida = false;
            };
            //Se obtienen los ids de los registros activos
            if (pProduccion.activo === true && pProduccion.id) {
                iDSActivos.push({ id: pProduccion.id });
                //Se obtienen los ids de las reciba Seriales
                if (pProduccion.recibaSerialID) {
                    recibaSerialIDS.push({ id: pProduccion.recibaSerialID });
                }
            }
        });
        const resultado = { faltanDatos: fdatos, valido: cantidadValida, ids: iDSActivos, recibaSerialIDS: recibaSerialIDS }
        return resultado;
    };
    async function managePProduccion() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        const revisarDatos = await validacionesPProduccion(inputList);
        const cantidadesvalidas = revisarDatos.valido;
        const fdatos = revisarDatos.faltanDatos;
        try {
            if (fdatos || !fechaPlaneacion || cantidadesvalidas === false) {
                setMensajeAlert("Faltan datos o son erróneos: los campos marcados con un asterisco son obligatorios," +
                    "la cantidad del material agregado no pude ser mayor a la cantidad disponible, se marca en rojo los datos erróneos." +
                    "Faltan datos: " + (fdatos ? "Así es" : "No") + ", Fecha de planeación: " + fechaPlaneacion + ", Cantidades válidas: " + (cantidadesvalidas ? "Efectivamente" : "No"));
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                window.scrollTo(0, 0);
                setisDisabled(false);
            } else {
                //Variables auxiliares

                var numeroUP = 1;
                var pConcurrencia = false;
                var carga = false;
                var terminado = false;
                var pproduccionGID = "";
                //Se obtienen los planes de producción con la fecha del plan de producción en cuestión.                
                setMensajeAlert("Obteniendo datos; 1");
                const pproduccionF = await GetPProduccion({ fechaDePlaneacion: { eq: fechaPlaneacion }, activo: { eq: true } });
                //Si es una inserción, se obtiene el número que le corresponde
                if (editar === false) {
                    setMensajeAlert("Operación errónea editar; 1");
                    //Se revisa si ya existe un plan de producción con la fecha elegida
                    if (pproduccionF.length > 0) {
                        window.scrollTo(0, 0);
                        setMensajeAlert("No fue posible realizar la operación: Ya existe un Plan de producción con la fecha elegida, " +
                            "favor de elegir otra fecha y volver a intentarlo (1)");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        setisDisabled(false);
                        return;

                    }
                    setMensajeAlert("Obteniendo datos; 2");
                    const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                    const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                    await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                        numeroUP = ultimaplaneacion.numero + 1;
                        ultimaplaneacion.numero = numeroUP;

                        delete ultimaplaneacion.createdAt;
                        delete ultimaplaneacion.updatedAt;
                        delete ultimaplaneacion.__typename;
                        ultimaplaneacion.Reg_Mod_Usuario = userName;
                        await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                        return ultimaplaneacion;
                    }))
                    if (!ultimapFromAPI.length) {
                        await API.graphql({
                            query: createPProduccionUltimoNumero, variables: {
                                input: {
                                    numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                                }
                            }
                        });
                    }

                } else {
                    setMensajeAlert("Obteniendo datos; 3");
                    //Se revisa si ya existe un plan de producción con la fecha elegida diferente al que se está editando.
                    const pproduccionFid = pproduccionF.filter(pproduccionf => pproduccionf.numero !== inputList[0].numero);
                    if (pproduccionFid.length > 0) {
                        window.scrollTo(0, 0);
                        setMensajeAlert("No fue posible realizar la operación: Ya existe un Plan de producción con la fecha elegida, " +
                            "favor de elegir otra fecha y volver a intentarlo (2) ");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        setisDisabled(false);
                        return;

                    }

                }
                //Se obtienen los datos del plan de producción por id para revisar la concurrencia 
                setMensajeAlert("Revisando concurrencia; 1");
                var datosPProduccionC = []
                //Se buscan datos del plan de producción
                const datosPProduccion = inputList.filter(planProduccion => planProduccion.id);
                if (datosPProduccion.length > 0) {
                    datosPProduccionC = await GetPProduccion({ and: [{ numero: { eq: datosPProduccion[0].numero } }, { activo: { eq: true } }] })
                }
                //------------------------------------------------------------------------------------------------------------------------------------------------
                var InputListM = inputList.filter(pproduccionM => !pproduccionM.id || (pproduccionM.id &&
                    (pproduccionM.cantidadPiezas !== pproduccionM.cantidadOriginal || pproduccionM.prioridad !== pproduccionM.prioridadOriginal ||
                        pproduccionM.racks !== pproduccionM.ppracksOriginal || pproduccionM.materialEnCantidad !== pproduccionM.materialEnCantidadOriginal ||
                        pproduccionM.ciclos !== pproduccionM.ciclosOriginal || pproduccionM.activo === false)))
                setMensajeAlert("Revisando concurrencia; 2");
                await Promise.all(InputListM.map(async pProduccion => {
                    //Se revisa concurrencia en pProducción
                    if (pProduccion.id) {//Si existe el id del plan de producción
                        //Se obtienen los datos                         
                        const pproduccionC = await datosPProduccionC.filter(pp => pp.id === pProduccion.id);
                        //setMensajeAlert("Revisando concurrencia; 3");
                        //Se revisa la concurrencia
                        if (pproduccionC.length < 1) { //Si no se obtuvieron los datos, se marca como concurrencia
                            pConcurrencia = true;
                            setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en  PProducción (1)");
                        } else {//Si se encontraron datos, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos 
                            if (pProduccion.updatedAt !== pproduccionC[0].updatedAt) {
                                pConcurrencia = true;
                                setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en  PProducción (2)");
                            }
                        }
                        if (pProduccion.activo === false && ((pproduccionC[0].piezasenCarga > 0 || pproduccionC[0].piezasenPintado > 0)
                            || pproduccionC[0].FechaTransferencia))
                            carga = true;
                        if (pProduccion.cantidadOriginal !== pProduccion.cantidadPiezas && pproduccionC[0].FechaTransferencia)
                            terminado = true;
                        //setMensajeAlert("Revisando concurrencia; 4");
                    }

                    //Se revisa concurrencia en recibaSeriales
                    if (pProduccion.desdeAlmacen === true) {
                        //Se obtinen los datos
                        //Se filtra recibaSinFiltro para obtener el dato de reciba con el que se está trabajando
                        setMensajeAlert("Revisando concurrencia; 7");
                        const recibaDatosAc = await GetRecibaSerialesID(pProduccion.recibaSerialID);
                        setMensajeAlert("Revisando concurrencia; 8");
                        //Se revisa la concurrencia
                        if (!recibaDatosAc) { //Si no se obtuvieron los datos, se marca como concurrencia
                            pConcurrencia = true;
                            setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en  Reciba (0.5)" + JSON.stringify(recibaDatosAc));
                        } else { //Si se encontraron datos
                            //Se filtra recibaSinFiltro para obtener el dato de reciba con el que se está trabajando
                            const recibaDatos = recibaSinFiltro.filter(recibad => recibad.recibaSerialID === pProduccion.recibaSerialID)
                            if (recibaDatos.length < 1) { //Si no encuentra el dato, se marca como concurrencia
                                pConcurrencia = true;
                                setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en reciba (1)");
                            } else { //Si se encuentra el dato, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos
                                if (recibaDatosAc.updatedAt !== recibaDatos[0].updatedAt) {
                                    pConcurrencia = true;
                                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia,  en reciba  (2)");
                                }
                            }

                        }

                    }
                    //setMensajeAlert("Revisando concurrencia; 7");
                }));
                //setMensajeAlert("Revisando concurrencia; 3");
                if (carga) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: uno o más registros que se intentan eliminar ya tienen registro  en carga y/o ya se transfirieron al plan de producción de otro día.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    return;
                }
                if (terminado) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: uno o más registros a los que se intenta modificar la cantidad, ya se pasaron al plan de producción de otro día.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    return;
                }
                //setMensajeAlert("Revisando concurrencia; 4");
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en planeaciones
                if (pConcurrencia === false) {
                    //Si no se trata de una edición, se crean los registros en planeación general y plan de producción general
                    if (!editar) {//Si es una inserción. 
                        //Se crea el registro de la plan de producción general
                        setMensajeAlert("Problemas al guardar la planeación general 1");
                        let resulppg = await API.graphql({
                            query: createPProduccionGeneral, variables: {
                                input: {
                                    fechaDePlaneacion: fechaPlaneacion,
                                    numero: numeroUP,
                                    espacioVacio: 0,
                                    activo: true,
                                    Reg_Ins_Usuario: userName
                                }
                            }
                        });
                        pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                    } else {

                        //Se revisa si uno de los registros que se está editango tiene el dato de pproduccionGeneralID
                        const regPProduccionG = inputList.filter(pproduccion => (pproduccion.pproduccionGeneralID ? pproduccion.pproduccionGeneralID : "") != "");
                        if (regPProduccionG.length > 0) {
                            pproduccionGID = regPProduccionG[0].planeacionGeneralID;
                        } else {
                            //Se revisa si ya hay un plan de producción de la fecha en cuestión.
                            const pproduccionG = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: datosPProduccion[0].numero } }, { activo: { eq: true } }] });
                            if (pproduccionG.length > 0) {
                                pproduccionGID = pproduccionG[0].id;

                            } else {
                                //Se crea el registro del plan de producción general
                                setMensajeAlert("Problemas al guardar la planeación general 1");
                                let resulppg = await API.graphql({
                                    query: createPProduccionGeneral, variables: {
                                        input: {
                                            fechaDePlaneacion: fechaPlaneacion,
                                            espacioVacio: 0,
                                            numero: datosPProduccion[0].numero,
                                            activo: true,
                                            Reg_Ins_Usuario: userName
                                        }
                                    }
                                });
                                pproduccionGID = resulppg.data.createPProduccionGeneral.id;
                            }
                        }

                    }
                    setMensajeAlert("Revisando reciba; 1");
                    //Se obtienen los datos actuales de la reciba    
                    var cantidadRecibidaAlmacen = 0;
                    //Se declaran variables auxiliares para obtener los ids de planeación y plan de producción.
                    var pproduccionIDS = [];
                    var rSerialesIDS = [];
                    var planeacionIDS = [];
                    var planeacionIDSC = [];
                    await Promise.all(InputListM.map(async (pProduccion, i) => {
                        if (!pProduccion.piezasPintadas)
                            pProduccion.piezasPintadas = 0;
                        //Actualiza la cantidad en reciba seriales
                        if (pProduccion.cantidadOriginal !== pProduccion.cantidadPiezas || pProduccion.activo === false) {
                            if (pProduccion.desdeAlmacen === true || pProduccion.PlaneacionID) {
                                //Se obtienen los datos
                                const recibaDatosA = await GetRecibaSerialesID(pProduccion.recibaSerialID);
                                if (recibaDatosA.id) {
                                    const reciba = recibaDatosA;
                                    const cantidadPlaneada = pProduccion.cantidadOriginal === 0 ? (parseInt(pProduccion.cantidadPlaneadaOriginal) + parseInt(pProduccion.cantidadPiezas)) :
                                        pProduccion.activo === false ? reciba.cantidadPlaneada - pProduccion.cantidadOriginal :
                                            pProduccion.cantidadPiezas === pProduccion.cantidadOriginal ? reciba.cantidadPlaneada :
                                                pProduccion.cantidadPiezas > pProduccion.cantidadOriginal ?
                                                    parseInt(reciba.cantidadPlaneada) + parseInt(pProduccion.cantidadPiezas - pProduccion.cantidadOriginal) :
                                                    parseInt(reciba.cantidadPlaneada) - parseInt(pProduccion.cantidadOriginal - pProduccion.cantidadPiezas);
                                    cantidadRecibidaAlmacen = reciba.cantidadRecibida;
                                    delete reciba.updatedAt;
                                    delete reciba.__typename;
                                    delete reciba.createdAt;
                                    reciba.Reg_Mod_Usuario = userName;
                                    reciba.cantidadPlaneada = cantidadPlaneada > reciba.cantidadRecibida ? reciba.cantidadRecibida : cantidadPlaneada;
                                    setMensajeAlert("Problemas al actualizar los datos de reciba ");//+ JSON.stringify(pProduccion) 
                                    let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: reciba } });

                                    const recibaSerialMPID = reciba.recibaSerialMPID;
                                    if (reciba.recibaSerialMPID) {
                                        delete reciba.recibaSerialMPID;
                                        reciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                                        await API.graphql({
                                            query: updateRecibaSerialesMP,
                                            variables: { input: { ...reciba, id: recibaSerialMPID } },
                                        });
                                    }
                                }
                            }
                        }
                        //Creación o actualización de registro en pProducción
                        if (pProduccion.desdeAlmacen === true)
                            pProduccion.racksOriginal = pProduccion.racks;
                        pProduccion.desdePproduccion = true;
                        delete pProduccion.cantidadPlaneadaOriginal;
                        delete pProduccion.cantidadDisponible;
                        delete pProduccion.cantidadOriginal;
                        delete pProduccion.prioridadOriginal;
                        delete pProduccion.ppracksOriginal;
                        delete pProduccion.materialEnCantidadOriginal;
                        delete pProduccion.ciclosOriginal;
                        if (pProduccion.activo)
                            pProduccion.orden = pProduccion.prioridad;
                        if (!editar) {
                            //Se crea un registro para el plan de producción
                            pProduccion.fechaDePlaneacion = fechaPlaneacion;
                            pProduccion.pproduccionGeneralID = pproduccionGID;
                            pProduccion.Reg_Ins_Usuario = userName;
                            pProduccion.numero = numeroUP;
                            delete pProduccion.planeacionGeneralID;
                            setMensajeAlert("Problemas al guardar el plan de producción ");//+ JSON.stringify(pProduccion) 
                            let resultpp = await API.graphql({ query: createPProduccion, variables: { input: pProduccion } });
                            pproduccionIDS.push({ id: resultpp.data.createPProduccion.id, nuevo: true, activo: true });
                            rSerialesIDS.push({ id: resultpp.data.createPProduccion.recibaSerialID, nuevo: true, activo: true });
                        } else {
                            pProduccion.fechaDePlaneacion = fechaPlaneacion;
                            if (pProduccion.id) {
                                delete pProduccion.createdAt;
                                delete pProduccion.updatedAt;
                                delete pProduccion.__typename;
                                delete pProduccion.completo;
                                delete pProduccion.piezasATransferir;
                                delete pProduccion.piezasCompletas;
                                delete pProduccion.piezasCargadas;
                                delete pProduccion.transferido;
                                pProduccion.Reg_Mod_Usuario = userName;
                                setMensajeAlert("Problemas al actualizar el plan de producción ");//+ JSON.stringify(pProduccion) 
                                let resultpp = await API.graphql({ query: updatePProduccion, variables: { input: pProduccion } });
                                if (pProduccion.activo === false) {
                                    pproduccionIDS.push({ id: resultpp.data.updatePProduccion.id, nuevo: false, activo: false });
                                    rSerialesIDS.push({ id: resultpp.data.updatePProduccion.recibaSerialID, nuevo: false, activo: false });

                                }
                            } else {//Se crea un registro para la planeación.                               
                                //Se crea un registro para el plan de producción
                                pProduccion.desdePproduccion = true;
                                pProduccion.Reg_Ins_Usuario = userName;
                                pProduccion.numero = numeroP;
                                pProduccion.pproduccionGeneralID = pproduccionGID;
                                delete pProduccion.planeacionGeneralID;
                                setMensajeAlert("Problemas al guardar el plan de producción ");//+ JSON.stringify(pProduccion) 
                                let resultpp = await API.graphql({ query: createPProduccion, variables: { input: pProduccion } });
                                pproduccionIDS.push({ id: resultpp.data.createPProduccion.id, nuevo: true, activo: true });
                                rSerialesIDS.push({ id: resultpp.data.createPProduccion.recibaSerialID, nuevo: true, activo: true });
                            }
                        }
                    }));

                    //actualiza el registro general del plan de producción
                    const PProduccionG = await GetPProduccionGeneralID(pproduccionGID);
                    const ppgids = PProduccionG.PProduccionIDS ? PProduccionG.PProduccionIDS.length > 0 ? PProduccionG.PProduccionIDS : [] : [];
                    const datosPPINDS = await combinarIDS(ppgids, pproduccionIDS);

                    const rsgids = PProduccionG.recibaSerialIDS ? PProduccionG.recibaSerialIDS.length > 0 ? PProduccionG.recibaSerialIDS : [] : [];
                    const datosRSerialIDS = await combinarIDS(rsgids, rSerialesIDS);

                    setMensajeAlert("Problemas al actualizar el plan de producción general 4 " + JSON.stringify(PProduccionG));
                    const rPProduccion = {
                        ...PProduccionG,
                        PProduccionIDS: datosPPINDS,
                        recibaSerialIDS: datosRSerialIDS,
                        activo: datosPPINDS.length > 0 ? true : false,
                        Reg_Mod_Usuario: userName
                    };
                    delete rPProduccion.createdAt;
                    delete rPProduccion.updatedAt;
                    delete rPProduccion.__typename;
                    setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                    await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });


                    setMensajeAlert("Operación exitosa");
                    setisDisabled(false);
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    //fetchPlaneaciones(rpfechaini, rpfechafin);
                    fetchPlanProduccion(rfechaini, rfechafin);
                    fetchReciba();
                    setEditar(false);
                    setFechaPlaneacion("");
                    toggle1('1');
                    /*fetchAlmacen();
                    palmacen(); */
                } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                        " volver a intentarlo");*/
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                }

            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            setisDisabled(false);
        }
    };
    //Indicador de vista del más actual al más antigüo en almacén
    function onChangescheckVUAP(e) {
        setVistaUltimoAP(e.target.checked);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, e.target.checked);
    }
    //Registrar planeación y plan de Producción general
    async function actualizarPPPGeneral() {
        try {
            //Filtro por material en planta
            setCargando(true);
            const result = await actualizarPPPGeneralM(fechaPlaneacionM, userName);
            //SetDatosResultado(result.registros);
            setMensajeAlert(result.mensaje);
            setColor(result.color);
            fetchPlanProduccion(rfechaini, rfechafin);
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    return {
        bloquearAgregado,
        verpproducciones,
        pproducciones,
        formType,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        cargando1,
        pPlanProduccion,
        fechaPlaneacionM,
        activeTab,
        editar,
        ppproduccion,
        pproduccionInspeccion,
        pproduccionCalidad,
        pproduccionRecuperacion,
        verpplaneacion,
        pProduccion,
        pProduccionIncompleta,
        fechaPPBusqueda,
        rfechaini,
        rfechafin,
        modal2,
        aceptarFinalizar,
        sumProduccionp,
        sumICiclos,
        sumPiezasPP,
        modal,
        fPDisabled,
        buscarporFecha,
        fechaPlaneacionS,
        currentPagePProduccion,
        paginasP,
        pageRange,
        ultimoNumeroPP,
        fechaPlaneacionP,
        pcargando,
        planeaciones,
        rpfechaini,
        rpfechafin,
        sumProduccion,
        sumCiclos,
        currentPagePlaneacion,
        paginas,
        ultimoNumeroP,
        searchBy,
        reciba,
        currentPage,
        recordPerPage,
        totalRecords,
        rPANOFIFO,
        search,
        modal3,
        noFIFOUsuarios,
        noFIFOUsuarios2,
        fechaPlaneacion,
        inputList,
        isDisabled,
        componentRef,
        regresaraAlmacen,
        dhRegresaraAlmacen,
        textPQR,
        vistaNumeroParte,
        espaciosVacios,
        dataChart,
        pProduccionSinFiltro,
        recibaSinFiltro,
        onChangescheckVNP,
        setAceptarFinalizar,
        clicConQR,
        handleError,
        handleScan,
        onChangesFPPTodo,
        onChangesRegresarMaterial,
        setPProduccionIncompleta,
        toggle1,
        onDismiss,
        clicBuscarporFecha,
        onSearchFechaPProduccion,
        handlePageChangePProduccion,
        clicAdddePlaneacion,
        clicEliminar,
        clicEditar,
        clicFinalizarPP,
        handlePrint,
        clicNuevaPlaneacion,
        fetchPlanProduccion,
        onChangesRFechaPP,
        onSearchFecha,
        setModal2,
        toggle,
        aceptarEliminar,
        toggle2,
        aceptarFinalizarPP,
        onChangesRPFecha,
        fetchPlaneaciones,
        fetchReciba,
        onSearch,
        handlePageChangePlaneacion,
        buscarpor,
        setSearch,
        onChangescheckVUAP,
        obtenerUltimaUbicaciont,
        clicAdddeAlmacen,
        handlePageChange,
        toggle3,
        cancelarRANOFIFO,
        setComentariosNoFIFO,
        setUsuarioAutNoFIFO,
        setUsuarioAutNoFIFO2,
        aceptarRANOFIFO,
        setFechaPlaneacion,
        setInputList,
        handleInputChange,
        handleRemoveClick,
        cancelarpProduccion,
        managePProduccion,
        onChangesfechaPPS,
        actualizarPPPGeneral
    }
}